import { Field, FieldArray, Form, Formik } from "formik";
import {
  Autocomplete,
  Backdrop,
  CircularProgress,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { Component } from "react";

import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import Footer from "../../Component/Footer";
import Header from "../../Component/Header";
import Menu from "../../Component/Menu";
import {
  userid,
  currentTenant,
  taxtype,
  thousandsdisplay,
  ccountry,
  cstate,
  transactionFrom,
  theme,
} from "../../Common/Credentials.js";
import { FormikTextField } from "../../CommonComponents/FormField.js";
import SalesServices from "../SalesServices";
import {
  Box,
  Checkbox,
  Collapse,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  styled,
  Slider,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import UserService from "../../users/UserService.js";
import { Button, Card, Spinner } from "react-bootstrap";
import { Table } from "@mui/material";
import { TableCell } from "@mui/material";
import UomServices from "../../Masters/Uom/UomServices.js";
import MasterService from "../../Masters/MasterService.js";
import moment from "moment";
import IOSSwitch from "../../CommonComponents/IOSSwitch.js";
import InventoryService from "../../inventory/InventoryService";
import CategoryServices from "../../Masters/Category/CategoryServices";
import { NumericFormat } from "react-number-format";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Grid } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import WarehouseServices from "../../Masters/Warehouse/WarehouseServices";
import SettingsServices from "../../Settings/SettingsServices";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import AgentServices from "../../Masters/Agents/AgentServices";
import UsercustomerService from "../../Masters/Usercustomers/UsercustomerService";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Swal from "sweetalert2";
import UpArrow from "../../images/Icons/up-arrow.png";
import DepartmentServices from "../../Masters/Department/DepartmentServices.js";
import { OSSwitch } from "../../NewUI/NewComponents/OSSwitch.jsx";
import { SelectableRadio } from "../../NewUI/NewComponents/SelectableRadio.jsx";
import RectangularTabButton from "../../NewUI/NewComponents/RectangularTabButton.jsx";
import AutoCompeteField from "../../NewUI/NewComponents/AutoCompeteField.jsx";
import TextfieldComponent from "../../Component/TextfieldComponent.jsx";
import SelectField from "../../NewUI/NewComponents/SelectField.jsx";
import TextareaField from "../../NewUI/NewComponents/TextareaField.jsx";
import DatePickerField from "../../NewUI/NewComponents/DatePickerField.jsx";
import dayjs from "dayjs";
import RoundedTabButton from "../../NewUI/NewComponents/RoundedTabButton.jsx";
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";
import { toast } from "../../NewUI/NewComponents/toastService.js"
import CustomAutocomplete from "../../NewUI/NewComponents/CustomAutocomplete.jsx";
import { BoxesIcon, BoxIcon, BriefcaseBusinessIcon, Plus, Users, WrenchIcon } from "lucide-react";
import TaxServices from "../../Masters/Tax/TaxServices.js";

let datalist = [];
let updatedatalist = [];
let list = {};
let count = 0;
let serviceList = [];

// let buffer = 0;
//  let progress
// const styles = (theme) => ({
//   table: {
//     display: "block",
//     width: "100%",
//     overflowX: "auto",
//   },
// });
// const BorderLinearProgress = styled((theme) => ({
//   root: {
//     height: 15,
//     borderRadius: 5,
//   },
//   colorPrimary: {
//     backgroundColor: "#EEEEEE",
//   },
//   bar: {
//     borderRadius: 5,
//     backgroundColor: "#1a90ff",
//   },
// }))(LinearProgress);

const useStyles = styled((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  details: {
    alignItems: "center",
  },
  column: {
    flexBasis: "33.33%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
  },
}));

const TabButton = ({ active, onClick, children }) => (
  <fieldset
    onClick={onClick}
    className={`tab-button ${active ? "active-tab" : "inactive-tab"}`}
    style={{
      cursor: "pointer",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      borderRadius: "50px",
      border: "1px solid #e2e8f0",
      padding: "8px 16px",
      fontSize: "0.8rem",
      fontWeight: 500,
    }}
  >
    {children}
    <img
      src={UpArrow}
      alt="Up Arrow"
      style={{
        width: "1.5rem",
        height: "1.5rem",
        padding: "4px",
        transform: active ? "rotate(30deg)" : "rotate(0deg)",
        transition: "transform 0.3s ease",
      }}
    />
  </fieldset>
);

const isInvalid = ["",0,"0",null,"null",NaN,"NaN",undefined]

class NewQuotation extends Component {
  constructor(props) {
    super(props);
    const pagename =
      this.props.location.state === undefined
        ? this.history.props.push("/saleorder")
        : this.props.location.state.pagename;
    const id =
      this.props.location.state === undefined
        ? this.history.props.push("/saleorder")
        : this.props.location.state.id;

    this.state = {
      pagename: pagename,
      datatoupdate: "",
      usercustomers: [],
      id: id,
      salestype: "0",
      soid: "",
      ordertype: false,
      iid: "",
      custom: [],
      customer: "",
      agentsdata: [],
      agentreq: false,
      agent: "",
      agentid: "",
      itemid: "",
      itemList: [],
      saleorderdata: [],
      itemname: "",
      hsnid: "",
      hsn: "",
      custid: "",
      quantity: "",
      pricevariance: 0,
      cost: "",
      type: "LIFO",
      uom: "",
      uomid: "",
      UOMList: [],
      warehouse: "",
      whid: null,
      WarehouseList: [],
      whdata: [],
      deptid:"",
      department:"",
      DepartmentList:[],
      CategoryList: [],
      categoryid: "",
      category: "",
      stock: "",
      taxrequired: true,
      taxesList: [],
      taxtype: taxtype,
      taxtypelist:["GST","VAT"],
      gsttypelist:["INTRASTATE","INTERSTATE"],
      tax: "",
      cgst: "",
      sgst: "",
      additionalparams: 0,
      taxamount: 0,
      cctaxamount: 0,
      totaltaxamount: 0,
      cctotaltaxamount: 0,
      totalprice: 0,
      cctotalprice: 0,
      totaliv: 0,
      cctotaliv: 0,
      totalpricewtax: 0,
      cctotalpricewtax: 0,
      grandtotal: 0,
      ccgrandtotal: 0,
      grandproducttotal: 0,
      ccgrandproducttotal: 0,
      listData: [],
      status: 0,
      description: "",
      creditperiod: "",
      creditvalue: "",
      creditstatus: "",
      availabelcredit: "",
      initialCredit: "",
      gsttype: "INTRASTATE",
      ledgerid: "",
      UserPermissions: "",
      preitemList: [],
      filteritemlist: [],
      size: "",
      colour: "",
      thickness: "",
      brand: "",
      model: "",
      totalmtrroll: "",
      sizelist: [],
      colourlist: [],
      thicknesslist: [],
      brandslist: [],
      advance: 0,
      advancecnvt: 0,
      advancestatus: false,
      paymentterms: 0,
      filterserv: [],
      ServiceCategoryList: [],
      serviceitemList: [],
      serviceList: [],
      deleteditems:[],
      deletedservices:[],
      servicediscount:0,
      servicemarkup:0,
      servicemarkupconv:0,
      service: "",
      serviceid: "",
      servicecategory: "",
      servicecatid: "",
      servicecode: "",
      servicetax: "",
      servicecost: "",
      servicecostconv: 0,
      servicecgst: "",
      servicesgst: "",
      serviceigst: "",
      servicegst: "",
      servicevat: "",
      servicetaxamount: "",
      servicecostwttaxconv: 0,
      servicecostwttax: "",
      servicedescription: "",
      servicetotal: "",
      servicetotalconv:"",
      servicetotalwtax: "",
      serviceerr: "",
      servicediscountamount:0,
      servicediscountamountconv:0,
      grandservicetotal: 0,
      ccgrandservicetotal:0,

      milestone: [],
      recurringtype: [],
      contracttypeList: [],
      contracttype: "",
      contracttime: "NotApplicable",
      contractstartdate: new Date(),
      contractenddate: new Date(),
      milestonesavebtn: false,
      percentagemessage: "",

      pro: true,
      serv: false,
      prosev: false,
      sloader: false,
      soeditprice: "NO",
      open: false,
      currencylist: [],
      currencyid: "",
      currency: "",
      curconversionrate: 1,
      basecurrency: "",
      convertionreq: false,
      custcountry: "",
      advoptions: "",
      settings: "",
      markup:0,
      markup1:0

      // partyid: "",
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  handleProductChange = (pro,serv,prosev) => {
    this.setState({
      pro: pro,
      serv: serv,
      prosev: prosev,
      salestype: pro?"0":serv?"1":"2",
      itemname: "",
      hsnid: "",
      hsn: "",
      quantity: "",
      pricevariance: 0,
      cost: "",
      uom: "",
      uomid: "",
      description: "",
      creditperiod: "",
      creditvalue: "",
      creditstatus: "",
      availabelcredit: "",
      initialCredit: "",
      gsttype: "INTRASTATE",
      size: "",
      colour: "",
      thicknes: "",
      brand: "",
      totalmtrroll: "",
      service: "",
      serviceid: "",
      servicecategory: "",
      servicecatid: "",
      servicecode: "",
      servicetax: "",
      servicecost: "",
      servicecostwttax: "",
      servicetaxamount: "",
      servicedescription: "",
      servicetotal: "",
      serviceerr: "",
      grandservicetotal: 0,
      categoryid: "",
      category: "",
      stock: "",
      tax: "",
      cgst: "",
      sgst: "",
      additionalparams: 0,
      taxamount: 0,
      totaltaxamount: 0,
      totalprice: 0,
      totaliv: 0,
      totalpricewtax: 0,
      grandtotal: 0,
      listData: [],
    });
    datalist = [];
  };
  GetCurrencySymbol = (cy) =>{
    return this.state.currencyList && this.state.currencyList.length>0 && this.state.currencyList.find(e=>e.currency === cy)?this.state.currencyList.find(e=>e.currency === cy).symbol:cy
  }

  handleCurrency = (value, values) => {
    if (value !== "") {
      this.setState({ currencyid: values.id, currency: values.currency });
    } else {
      this.setState({ currencyid: "", currency: "" });
    }
  };

  // handleDiscountChange=e=>{
  //   this.setState({
  //     discount: e.target.value,
  //   })
  // }

  handlemarkup1Change = (e)=>{
    this.setState({
      markup1: e.target.value,
      totalpricewtax: 0,
    })
    // if (this.state.creditstatus !== "NotRequired") {
    //   if (this.state.availabelcredit < 0) {
    //     this.setState({ availabelcredit: this.state.creditvalue });
    //   } else {
    //   }
    // }
  }

  handleTypeChange = (e) => {
    this.setState({ type: e.target.value });
  };

  handlemulticurrencyrequired = () => {
    this.setState({ convertionreq: !this.state.convertionreq });
  };

  handleCurconversionrate = (e) => {
    this.setState({
      curconversionrate: e.target.value,
    });
  };

  handlesale = (e) => {
    this.setState({ salestype: e.target.value });
  };

  handleadvancestatus = (e) => {
    this.setState({ advancestatus: !this.state.advancestatus, advance: 0 });
  };

  onSubmit = () => {
    count = count + 1;

    // this.state.itemList.find(e=>e.itemid = this.state.itemid).totalstock = this.state.itemList.find(e=>e.itemid = this.state.itemid).totalstock - this.state.quantity
    // (this.state.whdata.find(e => e.whid === this.state.whid).saleslist).find(e => e.itemid === this.state.itemid).totalstock = (this.state.whdata.find(e => e.whid === this.state.whid).saleslist).find(e => e.itemid === this.state.itemid).totalstock - this.state.quantity
    let quantity = (isInvalid.includes(this.state.quantity)?0: parseFloat(this.state.quantity))
    let cost = ((isInvalid.includes(this.state.cost)?0: parseFloat(this.state.cost))  * (isInvalid.includes(this.state.curconversionrate)?1: parseFloat(this.state.curconversionrate))) * quantity
    let cccost = (isInvalid.includes(this.state.cost)?0: parseFloat(this.state.cost)) * quantity
    let markup = (isInvalid.includes(this.state.markup1)?0: parseFloat(this.state.markup1))  * (isInvalid.includes(this.state.curconversionrate)?1: parseFloat(this.state.curconversionrate))  * quantity
    let ccmarkup = (isInvalid.includes(this.state.markup1)?0: parseFloat(this.state.markup1)) * quantity
    let discountAmt = ((cost + markup) * ((isInvalid.includes(this.state.discount)?0: parseFloat(this.state.discount))/100))
    let ccdiscountAmt = ((cccost + markup) * ((isInvalid.includes(this.state.discount)?0: parseFloat(this.state.discount))/100))
    console.log(cost , markup, discountAmt)
    let total = cost + markup - discountAmt
    let cctotal = cccost + ccmarkup - ccdiscountAmt
    let taxAmt = (total)* ((isInvalid.includes(this.state.tax)?0: parseFloat(this.state.tax))/100)
    let cctaxAmt = (cctotal)* ((isInvalid.includes(this.state.tax)?0: parseFloat(this.state.tax))/100)

    this.setState(
      {
        
        totaliv: parseFloat(this.state.totaliv) + parseFloat(total),
        cctotaliv: parseFloat(this.state.cctotaliv) + parseFloat(cctotal),
        totaltaxamount: this.state.totaltaxamount + taxAmt,
        cctotaltaxamount: this.state.cctotaltaxamount + cctaxAmt,
        totaldiscount:this.state.totaldiscount + discountAmt,
        cctotaldiscount:this.state.totaldiscount + ccdiscountAmt,
        grandtotal: this.state.grandtotal + parseFloat(total+taxAmt),
        ccgrandtotal: this.state.ccgrandtotal + parseFloat(cctotal+cctaxAmt),
        creditvalue: this.state.availabelcredit,
        totalpricewtax:total + taxAmt,
        cctotalpricewtax:cctotal + cctaxAmt,
        taxamount:parseFloat(taxAmt),
        cctaxamount:parseFloat(cctaxAmt),
        totalprice:total,
        cctotalprice:cctotal,

        // totalinsuranceamount:this.state.totalinsuranceamount + this.state.insuranceamount,
        // stock: this.state.stock - parseInt(this.state.quantity),
       
      },
      () => {
        list = {
          soid: this.state.id,
          soidforadjust: this.state.soidforadjust,
          soitemidforadjust:this.state.soitemidforadjust,
          adjusted:this.state.soitemidforadjust !==null?parseFloat(this.state.quantity):0,
          customer: this.state.customer,
          custid: this.state.custid,
          itemid: parseInt(this.state.itemid),
          name: this.state.itemname,
          hsn: this.state.hsn,
          price: (cost + markup) / quantity,
          ccprice: (cccost + ccmarkup) / quantity,
          markup1:markup,
          ccmarkup1:ccmarkup,
          salesenum: this.state.type,
          quantity: parseFloat(this.state.quantity),
          pricevariance:parseFloat(this.state.pricevariance),
          totalprice: parseFloat(total),
          cctotalprice: parseFloat(cctotal),
          tax: parseFloat(this.state.tax),
          taxamount: taxAmt,
          cctaxamount: cctaxAmt,
          totalpricewtax: this.state.totalpricewtax,
          cctotalpricewtax: this.state.cctotalpricewtax,
          size: this.state.size,
          brand: this.state.brand,
          model:this.state.model,
          uom: this.state.uom,
          colour: this.state.colour,
          thickness: this.state.thickness,
          totalmtrroll: this.state.totalmtrroll,
          description: this.state.description,
          catid: this.state.catid,
          category: this.state.category,
          additionalparams: this.state.additionalparams,
          creditperiod: this.state.creditperiod,
          creditvalue: this.state.availabelcredit === '' ? 0 : this.state.availabelcredit,
          currencyid: this.state.currencyid,
          currency: this.state.currency,
          curconversionrate: parseFloat(this.state.curconversionrate),
          insurancereq:this.state.insurancereq,
          insurance:0,
          insuranceamount:0,
          discount:parseFloat(this.state.discount),
          discountamount:discountAmt,
          ccdiscountamount:ccdiscountAmt,
        };
        
        datalist.push(list);
        updatedatalist.push(list);
        this.setState({
          listData: datalist,
        });
        this.setState({
          quantity: "",
          totalpricewtax: "",
        });
      }
    );
  };
  

  handleSubmit = () => {
    // let filedata = this.state.fileInfos.map((e) => e.name).toLocaleString();
    // let path = prefix1 +"/" +doctype +"/" +this.state.partyid +"/" +year +"/" +curmonth +"/" +day;
    // if (filedata === "" && this.state.pofile === "") {
    //   this.setState({ message: "Please Upload Purchase Order" });
    // } else {
    this.setState({ sloader: true });
    // if (this.state.salestype === "1") {
    //   serviceList = [
    //     {
    //       service: this.state.service,
    //       serviceid: this.state.serviceid,
    //       servicecatid: this.state.servicecatid,
    //       servicecode: this.state.servicecode,
    //       servicecategory: this.state.servicecategory,
    //       servicecost: parseFloat(this.state.servicecost),
    //       servicetax: this.state.servicetax,
    //       description: this.state.servicedescription,
    //       servicetotal:
    //         parseFloat(this.state.servicecost) +
    //         parseFloat(this.state.servicecost) * (this.state.servicetax / 100),
    //       servicetotalwtax:
    //         parseFloat(this.state.servicecost) +
    //         parseFloat(this.state.servicecost) * (this.state.servicetax / 100),
    //       recurringtype: this.state.contracttime,
    //       milestonequotation: this.state.milestone,
    //       contracttype: this.state.contracttype,
    //       recurrencetill: this.state.contractstartdate,
    //       currencyid: this.state.currencyid,
    //       currency: this.state.currency,
    //       curconversionrate: parseFloat(this.state.curconversionrate),
    //       // contractenddate: this.state.contractenddate,
    //       // contractfile:filedata,
    //       // contractpath:path,
    //     },
    //   ];
    // }
    let sodata = {
      // pofile: this.state.pofile === "" ? filedata : this.state.pofile,
      // popath: this.state.popath === "" ? path : this.state.popath,
      id: this.state.id,
      sotype:parseInt(this.state.salestype),
      agent:
        this.state.agentid === "" || this.state.agentid === undefined
          ? null
          : this.state.agentid,
      creditstatus:
        this.state.creditstatus === undefined ? null : this.state.creditstatus,
      customer: this.state.customer,
      custid: this.state.custid,
      status: this.state.status,
      creditperiod:
        this.state.creditperiod === undefined ||
        this.state.creditperiod === null
          ? 0
          : this.state.creditperiod,
      creditvalue:
        this.state.availabelcredit === null ||
        this.state.availabelcredit === undefined
          ? 0
          : this.state.availabelcredit,
      gsttype: this.state.gsttype === "INTRASTATE" ? 0 :this.state.gsttype === "INTERSTATE"? 1:2,
      grandtotal: this.state.grandtotal,
      ccgrandtotal: this.state.ccgrandtotal,
      grandproducttotal: this.state.grandtotal,
      ccgrandproducttotal: this.state.ccgrandtotal,
      whid: this.state.whid,
      deptid:this.state.deptid,
      createdby: userid,
      updatedby: userid,
      tenantid: currentTenant,
      totaltaxamount: this.state.totaltaxamount,
      cctotaltaxamount: this.state.cctotaltaxamount,
      paymentterms: this.state.paymentterms,
      itemquotation:this.state.pagename === "Edit/Updated Quotation" ? updatedatalist : datalist,
      deleteditems:this.state.deleteditems, 
      deletedservices:this.state.deletedservices,
      servicequotation: this.state.serviceList,
      grandservicetotal: this.state.grandservicetotal,
      ccgrandservicetotal: this.state.ccgrandservicetotal,
      advancepaymentreq: this.state.advancestatus === false ? 0 : 1,
      advanceamountreq: parseFloat(this.state.advance),

      currencyid: this.state.currencyid,
      currency: this.state.currency,
      curconversionrate: parseFloat(this.state.curconversionrate),

      taxrequired: this.state.taxrequired,
      taxtype: this.state.taxtype === "GST" ? 0 : 1,
    };
    SalesServices.NewQuotation(sodata)
      .then((response) => {
       this.props.navigate({pathname:`/quotationdetails`}, {state:{id:response.data}});
      })
      .catch((e) => {
        this.setState({ sloader: false }, () => {
          if (e.response.data.error === "Unauthorized") {
            Swal.fire({
              title: `Your Session is Lost: Please login Back to resume`,
              text: ".",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            }).then(() => this.props.navigate("/"));
          } else {
            Swal.fire({
              title: `${e.response.data.message}`,
              text: ".",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            });
          }
        });
      });
  };

  handleordertype = (e) => {
    this.setState({ ordertype: !this.state.ordertype }, () =>
      this.state.ordertype === true
        ? SalesServices.GetallSaleOrderOfCustomer(this.state.custid)
            .then((res) => this.setState({ saleorderdata: res.data }))
            .catch((e) => {
              if (e.response.data.error === "Unauthorized") {
                alert("Your Session is Lost: Please login Back to resume");
                this.props.navigate(`/`);
              }
            })
        : ""
    );
    //  SalesServices.GetPreviousOrder(this.state.custid).then(res=>
    //   this.setState(
    //     {
    //       listData: res.data.prevsoitemlist,
    //       creditvalue: res.data.creditvalue,
    //       grandtotal: res.data.grandtotal,
    //       taxamount: res.data.taxamount,
    //       totaltaxamount: res.data.totaltaxamount,
    //       totaliv: res.data.totaliv,
    //       gsttype:res.data.gsttype=== "INTERSTATE"?'0':'1',
    //     }, () => {datalist = res.data.prevsoitemlist})
    //   )
  };
  handlegsttype = (e) => {
    this.setState({ gsttype: !this.state.gsttype });
  };

  handleSaleOrder = (value) => {
    if (value !== "" && this.state.saleorderdata.includes(value)) {
      this.setState({ saleorderid: value });
      const id = value;
      SalesServices.GetDataToUpdate(id)
        .then((response) =>
          this.setState({
            preitemList: response.data.saleorderitems,
          })
        )
        .catch((e) => {
          if (e.response.data.error === "Unauthorized") {
            alert("Your Session is Lost: Please login Back to resume");
            this.props.navigate(`/`);
          }
        });
    }
  };

  // handlepreitem = (value,values)=>{
  //   this.setState({ itemid: values.preitemname.id, itemname: value,quantity: '', totalpricewtax: '' });
  // }

  // handleConfirm = () => {
  //   this.setState({ status: 1 });
  //   SalesServices.ConfirmOrders(datalist).then(() =>
  //     this.props.navigate(`/salesorder`)
  //   );
  // };

  deleteSaleOrderItem(id) {
    let deleteditem = this.state.listData.filter((data) => data.id === id);
    let tp = deleteditem.map((data) => data.totalpricewtax);
    let tx = deleteditem.map((data) => data.taxamount);
    let ti = deleteditem.map((data) => data.totalprice);
    let newitemlist = this.state.listData.filter((data) => data.id !== id);
    this.setState({
      listData: newitemlist,
      grandtotal: this.state.grandtotal - tp,
      totaltaxamount: this.state.totaltaxamount - tx,
      totaliv: this.state.totaliv - ti,
      availabelcredit: this.state.availabelcredit - parseFloat(tp),
    });
    datalist = newitemlist;
    SalesServices.deleteSaleOrderItem(id).catch((e) => {
      if (e.response.data.error === "Unauthorized") {
        alert("Your Session is Lost: Please login Back to resume");
        this.props.navigate(`/`);
      }
    });
  }

  handleRequestCredit = () => {
    let customer = {
      customer: this.state.custid,
      status: 0,
    };
    SalesServices.RequestCridet(customer)
      .then(() => {
        alert("Request Sent Successflly");
      })
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      });
  };

  handleCustomer = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      this.setState({
        custid: values.id,
        customer: values.companyname,
        currency: values.currency,
        currencyid: this.state.currencylist.find(
          (e) => e.currency === values.currency
        ).id,
        taxtype: values.taxtype,
        gsttype:
          values.statename === cstate && values.countryname === ccountry
            ? "INTRASTATE"
            : "INTERSTATE",
        custcountry: values.countryname,
        convertionreq:
          values.currency === this.state.basecurrency ? false : true,
        ordertype: false,
        partyid: values.id,
        itemname: "",
        hsnid: "",
        hsn: "",
        quantity: "",
        cost: "",
        uom: "",
        uomid: "",
        description: "",
        size: "",
        colour: "",
        thicknes: "",
        brand: "",
        model: "",
        totalmtrroll: "",
        stock: "",
        tax: "",
        cgst: "",
        sgst: "",
        additionalparams: 0,
        taxamount: 0,
        totaltaxamount: 0,
        totalprice: 0,
        totaliv: 0,
        totalpricewtax: 0,
        grandtotal: 0,
        listData: [],
      });

      let customer = this.state.custom.filter(
        (data, key) => data.id === values.id
      );
      customer.map((data) =>
        this.setState(
          { ledgerid: data.ledgerid }
          //   , () => {
          //   if (this.state.ledgerid === null) {
          //     if (
          //       window.confirm(
          //         `Please Create a Ledger Account of ${this.state.customer}`
          //       )
          //     ) {
          //       this.props.navigate(`/newledgers`);
          //     } else {
          //       this.setState({ customer: "" });
          //       this.props.navigate(`/salesorder`);
          //     }
          //   }
          // }
        )
      );

      const id = values.id;
      SalesServices.GetCustomerTerms(id)
        .then((res) =>
          this.setState({
            creditstatus: res.data.creditstatus,
            creditvalue: res.data.creditleft,
            creditperiod: res.data.creditperiod,
            availabelcredit: res.data.creditleft,
            initialCredit: res.data.creditleft,
          })
        )
        .catch((e) => {
          if (e.response.data.error === "Unauthorized") {
            alert("Your Session is Lost: Please login Back to resume");
            this.props.navigate(`/`);
          }
        });
    } else {
      this.setState({ custid: "", customer: "",creditstatus:"",creditvalue:"",creditperiod:"",availabelcredit:"",initialCredit:"" });
    }
  };

  handleQuantityChange = (e) => {
    this.setState({ quantity: e.target.value });
    this.setState({ totalpricewtax: "" });
    if (this.state.creditstatus !== "NotRequired") {
      if (this.state.availabelcredit < 0) {
        this.setState({ availabelcredit: this.state.creditvalue });
      } else {
      }
    }
  };

  handlePricevariance = (e) => {
    this.setState({ pricevariance: e.target.value });
    this.setState({ totalpricewtax: "" });
    if (this.state.creditstatus !== "NotRequired") {
      if (this.state.availabelcredit < 0) {
        this.setState({ availabelcredit: this.state.creditvalue });
      } else {
      }
    }
  };

  handleUOM = (value, values) => {
    if (value !== "" && typeof values.uom === "object") {
      this.setState({ uomid: values.uom.id, uom: value });
    } else {
      this.setState({ uom: "", uomid: "" });
    }
  };

  handleSize = (value, values) => {
    if (
      values !== "" &&
      this.state.sizelist.includes(values) &&
      values !== null
    ) {
      this.setState({ size: values });
    } else {
      this.setState({ size: "" });
    }
  };

  handleColour = (value, values) => {
    if (
      values !== "" &&
      this.state.colourlist.includes(values) &&
      values !== null
    ) {
      this.setState({ colour: values });
    } else {
      this.setState({ colour: "" });
    }
  };

  // onSubmit = () => {
  //   this.setState(
  //     {
  //       totalpricewtax:
  //         this.state.cost * parseFloat(this.state.quantity) +
  //         (parseFloat(this.state.tax) *
  //           (this.state.cost * parseFloat(this.state.quantity))) /
  //           100 +
  //         ((this.state.cost * parseFloat(this.state.quantity) +
  //           (parseFloat(this.state.tax) *
  //             (this.state.cost * parseFloat(this.state.quantity))) /
  //             100) *
  //           this.state.pricevariance) /
  //           100,

  //       taxamount:
  //         (parseFloat(this.state.tax) *
  //           (this.state.cost * parseFloat(this.state.quantity))) /
  //           100 +
  //         (((parseFloat(this.state.tax) *
  //           (this.state.cost * parseFloat(this.state.quantity))) /
  //           100) *
  //           this.state.pricevariance) /
  //           100,

  //       totalprice:
  //         this.state.cost * parseFloat(this.state.quantity) +
  //         (this.state.cost *
  //           parseFloat(this.state.quantity) *
  //           this.state.pricevariance) /
  //           100,
  //     },
  //     () => {
  //       if (this.state.creditstatus !== "NotRequired") {
  //         this.setState({
  //           availabelcredit:
  //             this.state.availabelcredit -
  //             (this.state.cost * parseFloat(this.state.quantity) +
  //               (parseFloat(this.state.tax) *
  //                 (this.state.cost * parseFloat(this.state.quantity))) /
  //                 100 +
  //               ((this.state.cost * parseFloat(this.state.quantity) +
  //                 (parseFloat(this.state.tax) *
  //                   (this.state.cost * parseFloat(this.state.quantity))) /
  //                   100) *
  //                 this.state.pricevariance) /
  //                 100),
  //         });
  //       }
  //     }
  //   );
  // };

  handlepreitem = (value, values) => {
    if (this.state.whid === "" || this.state.warehouse === "") {
      alert("Please Select Org Unit");
    } else {
      if (value !== "" && typeof values.itemname === "object") {
        this.setState({
          itemid: values.preitemname.itemid,
          itemname: value,
          category: values.preitemname.category,
          categoryid: values.preitemname.categoryid,
          // cost: values.preitemname.price,
          uom: values.preitemname.uom,
          quantity: values.preitemname.quantity,
          pricevariance: values.preitemname.pricevariance,
          brand: values.preitemname.brand,
          size: values.preitemname.size,
          colour: values.preitemname.colour,
          thickness: values.preitemname.thickness,
          totalmtrroll: values.preitemname.totalmtrroll,
          totalpricewtax: "",
        });
        if (this.state.creditstatus !== "NotRequired") {
          if (this.state.availabelcredit < 0) {
            this.setState({ availabelcredit: this.state.creditvalue });
          }
        }
        const id = values.preitemname.itemid;
        let itemdata = this.state.itemList.filter((e) => e.itemid === id);
        itemdata.map((data) =>
          this.setState({
            type: data.type,
            cost: data.price,
            // stock: data.totalstock,
            hsn: data.hsn,
            tax: this.state.taxrequired === false ? 0 : data.tax,
            cgst: this.state.taxrequired === false ? 0 : data.tax / 2,
            sgst: this.state.taxrequired === false ? 0 : data.tax / 2,
            additionalparams: data.additionalparams,
          })
        );
        let warehousedata = this.state.whdata.filter(
          (e) => e.whid === this.state.whid
        );
        let saleslist = warehousedata.find((e) => e).saleslist;
        let a = saleslist.filter((e) => e.itemid === id);
        this.setState({ stock: a.map((e) => e.totalstock)[0] });
      }
    }
  };

  handleWarehouse = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      this.setState({
        warehouse: values.name,
        whid: values.id,
        ordertype: false,
        itemname: "",
        hsnid: "",
        hsn: "",
        quantity: "",
        pricevariance: 0,
        cost: "",
        uom: "",
        uomid: "",
        description: "",
      });
      DepartmentServices.deptbywarehouse(this.state.WarehouseList[0].id).then((response) =>{
        this.setState({
          DepartmentList: response.data
        })
        if(response.data.length ===1){
          this.setState({
            department: response.data[0].name,
            deptid: response.data[0].id
          })
        }
    });
    } else {
      this.setState({
        warehouse: "",
        whid: "",
        ordertype: false,
        itemname: "",
        hsnid: "",
        hsn: "",
        quantity: "",
        pricevariance: 0,
        cost: "",
        type: "",
        uom: "",
        uomid: "",
        description: "",
      });
      DepartmentServices.deptbywarehouse(this.state.WarehouseList[0].id).then((response) =>{
        this.setState({
          DepartmentList: response.data
        })
        if(response.data.length ===1){
          this.setState({
            department: response.data[0].name,
            deptid: response.data[0].id
          })
        }
    });
    }
  };

  handleAgent = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      this.setState({
        agent: values.name,
        agentid: values.id,
      });
    } else {
      this.setState({ agent: "", agentid: "" });
    }
  };

  handleCategory = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      this.setState({
        catid: values.id,
        category: values.category,
        filteritemlist: this.state.itemList.filter(
          (e) => e.catid === values.id
        ),
        itemid: "",
        itemname: "",
        hsn: "",
        tax: "",
        cost: "",
        quantity: "",
        pricevariance: 0,
      });
    } else {
      this.setState({
        itemid: "",
        itemname: "",
        hsn: "",
        tax: "",
        cost: "",
        quantity: "",
        pricevariance: 0,
        catid: "",
        category: "",
        filteritemlist: [],
      });
    }
  };

  handleitem = (value, values) => {
    if (this.state.whid === "" || this.state.warehouse === "") {
      toast("Please Select Org Unit","error");
    } else {
      if (value !== "" && typeof values === "object" && values !== null) {
        this.setState({
          itemid: values.itemid,
          itemname: values.name,
          quantity: "",
          pricevariance: 0,
          totalpricewtax: "",
        });
        if (this.state.creditstatus !== "NotRequired") {
          if (this.state.availabelcredit < 0) {
            this.setState({
              availabelcredit:
                this.state.creditvalue * this.state.curconversionrate,
            });
          }
        }
        const id = values.itemid;
        // SalesServices.getCost(id).then((res) =>
        let itemdata = this.state.itemList.filter((e) => e.itemid === id);
        itemdata.map((data) =>
          this.setState({
            type:
              data.type === undefined || data.type === null || data.type === ""
                ? "LIFO"
                : data.type,
            cost: (isInvalid.includes(data.price)?0:(data.price/this.state.curconversionrate).toFixed(2)),
            hsn: data.hsn,
            // tax: this.state.taxrequired === true ? data.tax : 0,
            // cgst: this.state.taxrequired === true ? data.tax / 2 : 0,
            // sgst: this.state.taxrequired === true ? data.tax / 2 : 0,
            additionalparams: data.additionalparams,
            description: data.description,
            uomid: data.uomid,
            uom: data.uom,
            brand: data.brand,
            model: data.model,
          })
        );
        let warehousedata = this.state.whdata.filter(
          (e) => e.whid === this.state.whid
        );
        let saleslist = warehousedata.find((e) => e).saleslist;
        let a = saleslist.filter((e) => e.itemid === id);
        this.setState({
          stock:
            a.map((e) => e.totalstock)[0] === undefined
              ? 0
              : a.map((e) => e.totalstock)[0],
        });
      } else {
        this.setState({ itemname: "", itemid: "" });
      }
    }
  };

  removeItemFromList(id) {
    let deleteditem = datalist.filter((person, index) => index === id);
    let ditem = deleteditem.find((data) => data.itemid);
    if(ditem.id !== undefined && ditem.id !== '' && ditem.id !== null){
      this.state.deleteditems.push(ditem?.id)
    }
    // let dquantity = deleteditem.map((data) => data.quantity);
    let tp = deleteditem.map((data) => data.totalpricewtax);
    let tx = deleteditem.map((data) => data.taxamount);
    let ti = deleteditem.map((data) => data.totalprice);
    const newlist = datalist.filter((person, index) => index !== id);

    if (this.state.creditstatus !== "NotRequired") {
      this.setState({
        availabelcredit:
          this.state.availabelcredit +
          ditem.totalpricewtax / this.state.curconversionrate,
        creditvalue:
          this.state.availabelcredit +
          ditem.totalpricewtax / this.state.curconversionrate,
      });
    }
    datalist = newlist;
    this.setState({
      listData: newlist,
      grandtotal: this.state.grandtotal - tp,
      totaltaxamount: this.state.totaltaxamount - tx,
      totaliv: this.state.totaliv - ti,
    });
    this.state.whdata
      .find((e) => e.whid === this.state.whid)
      .saleslist.find((e) => e.itemid === ditem.itemid).totalstock =
      this.state.whdata
        .find((e) => e.whid === this.state.whid)
        .saleslist.find((e) => e.itemid === ditem.itemid).totalstock +
      ditem.quantity;

    this.setState({
      stock: this.state.whdata
        .find((e) => e.whid === this.state.whid)
        .saleslist.find((e) => e.itemid === ditem.itemid).totalstock,
    });
    // this.state.itemList.find(e => e.itemid = this.state.itemid).totalstock = this.state.itemList.find(e => e.itemid = this.state.itemid).totalstock + dquantity
  }

  refreshData() {
    const { id } = this.props.location.state;
    datalist = [];
    list = {};
    updatedatalist = [];
    count = 0;
    serviceList = [];

    MasterService.GetAllCurrency().then((response) => {
      this.setState({ currencylist: response.data });
    });

    TaxServices.getTaxes(currentTenant).then(response => this.setState({ taxesList: response.data.sort((a, b) => a.tax - b.tax) }))

    MasterService.GetCurrencyOfTenant(currentTenant).then((response) => {
      this.setState({
        basecurrency: response.data.currency,
        currencyid: response.data.id,
        currency: response.data.currency,
        curconversionrate: 1,
      });
    });

    InventoryService.GetWHdata(currentTenant)
      .then((response) => {
        this.setState({ whdata: response.data });
      })
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      });

    InventoryService.GetItems(currentTenant).then((response) =>
      this.setState({
        itemList: response.data?.map(e=>{return {...e,label:e.itemcode?e.name+" - "+e.itemcode:e.name}}),
      })
    );

    SalesServices.retriveAllCustomers(currentTenant).then((res) =>
      this.setState({
        custom: res.data.filter((e) =>
          this.state.usercustomers.length === 0
            ? e
            : this.state.usercustomers.includes(e.companyname)
        ),
      })
    );

    MasterService.getParameters(currentTenant).then((res) => {
      this.setState({
        parameters: res.data,
        sizelist: res.data.size,
        colourlist: res.data.colour,
        thicknesslist: res.data.thickness,
        brandslist: res.data.brands,
      });
    });

    UomServices.getUOM(currentTenant).then((response) =>
      this.setState({
        UOMList: response.data,
      })
    );

    SalesServices.GetContrctType().then((response) => {
      this.setState({ contracttypeList: response.data });
    });
    SalesServices.GetRecurringduration().then((response) => {
      this.setState({ recurringtype: response.data });
    });

    CategoryServices.getCategory(currentTenant).then((response) =>
      this.setState({
        CategoryList: response.data.filter((e) => e.categorytype === "Product"),
        ServiceCategoryList: response.data.filter(
          (e) => e.categorytype === "Service"
        ),
      })
    );
    WarehouseServices.getWarehouses(currentTenant).then((response) =>
      this.setState(
        {
          WarehouseList: response.data,
        },
        () => {
          if (this.state.WarehouseList.length === 1) {
            this.setState({
              warehouse: this.state.WarehouseList[0].name,
              whid: this.state.WarehouseList[0].id,
            });
            DepartmentServices.deptbywarehouse(this.state.WarehouseList[0].id).then((response) =>{
              this.setState({
                DepartmentList: response.data
              })
              if(response.data.length ===1){
                this.setState({
                  department: response.data[0].name,
                  deptid: response.data[0].id
                })
              }
          });
          }
        }
      )
    );
    InventoryService.getServices(currentTenant).then((res) => {
      this.setState({ serviceitemList: res.data.map(e=>{ return {...e,label:e.servicecode?e.service+" - "+e.servicecode:e.service}}) });
    });

    AgentServices.getAgents(currentTenant).then((res) => {
      this.setState({ agentsdata: res.data });
    });

    SettingsServices.GetSettings(currentTenant).then((response) => {
      this.setState({
        settings: response.data,
        soeditprice: response.data.soeditprice,
        salescalreq: response.data.salescalreq,
      });
    });

    if (id < 1) {
      return;
    }

    SalesServices.GetQuotationbyId(id).then((res) =>
    {
      this.setState({
          listData: res.data.itemquotation,
          serviceList: res.data.servicequotation,
          contracttype:res.data.sotype==="Services"? res.data.servicequotation.find(e=>e)?.contracttype:"",
          contracttime:res.data.sotype==="Services"? (res.data.servicequotation.find(e=>e)?.recurringtype || "NotApplicable"):"NotApplicable",
          id: res.data.id,
          salestype: res.data.sotype==="Products"?"0":res.data.sotype==="Services"?"1":"2",
          custid: res.data.custid,
          customer: res.data.customer,
          warehouse: res.data.warehouse,
          whid: res.data.whid,
          agent:res.data.agent,
          agentid:res.data.agentid,
          agentreq:res.data.agent === null?false:true,
          creditvalue: res.data.creditvalue,
          initialCredit: res.data.creditvalue,
          creditperiod: res.data.creditperiod,
          availabelcredit: res.data.creditvalue,
          grandtotal: res.data.grandproducttotal,
          grandservicetotal: res.data.grandservicetotal,
          taxamount: res.data.taxamount,
          totaltaxamount: res.data.totaltaxamount,
          totaliv: res.data.totaliv,
          pofile: res.data.pofile,
          popath: res.data.popath,
          gsttype: res.data.gsttype,
          advance: res.data.advanceamountreq,
          advancestatus: res.data.advancepaymentreq === "True" ? true : false,
          paymentterms: res.data.paymentterms,
        },
        () => {
          datalist = res.data.itemquotation;
          serviceList = res.data.servicequotation;
          SalesServices.GetCustomerTerms(res.data.custid)
          .then((res) =>
            this.setState({
              creditstatus: res.data.creditstatus,
              creditvalue: res.data.creditleft-res.data.creditvalue,
              creditperiod: res.data.creditperiod,
              availabelcredit: res.data.creditleft - res.data.creditvalue,
              initialCredit: res.data.creditleft,
            })
          )
          .catch((e) => {
            if (e.response.data.error === "Unauthorized") {
              alert("Your Session is Lost: Please login Back to resume");
              this.props.navigate(`/`);
            }
          });
        }
      )
    }
    );
  }

  handleServicecategory = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      this.setState({
        servicecatid: values.id,
        servicecategory: values.category,
        filterserv: this.state.serviceitemList.filter(
          (e) => e.catid === values.id
        ),
        servicecost: "",
        servicecostwttax: "",
        servicetaxamount: "",
        milestonelist: [],
        percentagemessage: "",
        milestonesavebtn: false,
      });
    } else {
      this.setState({
        servicecatid: "",
        servicecategory: "",
        filterserv: [],
        servicecost: "",
        servicecostwttax: "",
        servicetaxamount: "",
        milestonelist: [],
        percentagemessage: "",
        milestonesavebtn: false,
      });
    }
  };

  handleService = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      this.setState({
        serviceid: values.id,
        service: values.service,
        // servicetax: this.state.taxrequired === true ? values.servicetax : 0,
        servicecode: values.servicecode,
        servicedescription: values.description,
        servicecost: "",
        servicecostwttax: "",
        servicetaxamount: "",
        milestonelist: [],
        percentagemessage: "",
        milestonesavebtn: false,
      });
    } else {
      this.setState({
        serviceid: "",
        service: "",
        servicetax: 0,
        servicecode: "",
        servicedescription: "",
        servicecost: "",
        servicecostwttax: "",
        servicetaxamount: "",
        milestonelist: [],
        percentagemessage: "",
        milestonesavebtn: false,
      });
    }
  };

  // handleServiceAmountChange = (e) => {
  //   this.setState({
  //     servicecost: e.target.value,
  //     servicecostconv:
  //       parseFloat(e.target.value) * this.state.curconversionrate,
  //     servicetaxamount:
  //       (this.state.servicetax / 100) * parseFloat(e.target.value),
  //     servicecgst:
  //       ((this.state.servicetax / 100) * parseFloat(e.target.value)) / 2,
  //     servicesgst:
  //       ((this.state.servicetax / 100) * parseFloat(e.target.value)) / 2,
  //     serviceigst: (this.state.servicetax / 100) * parseFloat(e.target.value),
  //     servicegst: (this.state.servicetax / 100) * parseFloat(e.target.value),
  //     servicevat: (this.state.servicetax / 100) * parseFloat(e.target.value),
  //     servicecostwttax:
  //       parseFloat(e.target.value) +
  //       (this.state.servicetax / 100) * parseFloat(e.target.value),
  //     servicecostwttaxconv:
  //       (parseFloat(e.target.value) +
  //         (this.state.servicetax / 100) * parseFloat(e.target.value)) *
  //       this.state.curconversionrate,
  //   });
  // };

  toNumber = (val, defaultValue = 0) => {
    const num = parseFloat(val);
    return Number.isFinite(num) ? num : defaultValue;
  };

  handleServiceAmountChange = (
  value,
  quantity = 0,
  servicemarkup = 0,
  servicediscount = 0
) => {

  const amount = this.toNumber(value);
  const qty = this.toNumber(quantity);
  const markup = this.toNumber(servicemarkup);
  const discount = this.toNumber(servicediscount);
  const tax = this.toNumber(this.state.servicetax);
  const conversionRate = this.toNumber(this.state.curconversionrate, 1);

  // Amount + markup × quantity
  const val = (amount + markup) * qty;

  // Discount
  const discountamount = val * (discount / 100);

  // After discount
  const grossval = val - discountamount;

  // Tax
  const taxamt = grossval * (tax / 100);

  // Half tax for CGST / SGST
  const halftaxAmt = grossval * (tax / 2 / 100);

  // Total including tax
  const totalWithTax = grossval + taxamt;

  console.log({
    amount,
    qty,
    markup,
    discount,
    tax,
    conversionRate,
    val,
    discountamount,
    grossval,
    taxamt,
    totalWithTax
  });

  this.setState({

    servicecost: (amount * conversionRate).toFixed(2),
    servicecostconv: amount,

    servicemarkup: (markup * conversionRate).toFixed(2),
    servicemarkupconv: markup,

    servicediscount: discount,

    servicediscountamount:
      (discountamount * conversionRate).toFixed(2),

    servicediscountamountconv:
      discountamount.toFixed(2),

    servicetaxamount:
      taxamt.toFixed(2),

    servicetaxamountconv:
      taxamt.toFixed(2),

    servicecgst:
      halftaxAmt.toFixed(2),

    servicesgst:
      halftaxAmt.toFixed(2),

    serviceigst:
      taxamt.toFixed(2),

    servicegst:
      taxamt.toFixed(2),

    servicevat:
      taxamt.toFixed(2),

    servicetotal:
      (grossval * conversionRate).toFixed(2),

    servicetotalconv:
      grossval.toFixed(2),

    // Base currency total
    servicecostwttax:
      (totalWithTax * conversionRate).toFixed(2),

    // Transaction currency total
    servicecostwttaxconv:
      totalWithTax.toFixed(2)

  });
};

  handleContracttype = (value, values) => {
    if (
      values !== "" &&
      this.state.contracttypeList.includes(values) &&
      values !== null
    ) {
      this.setState({ contracttype: values,quantity:values ==="Milestone"?1:0});
      
    } else {
      this.setState({ contracttype: "" });
    }
  };

  handlecontracttime = (value, values) => {
    if (
      values !== "" &&
      this.state.recurringtype.includes(values) &&
      values !== null
    ) {
      this.setState({ contracttime: values });
    } else {
      this.setState({ contracttime: "" });
    }
  };

  handleStartDateChange = (date) => {
    this.setState({ contractstartdate: date });
  };
  handleEndDateChange = (date) => {
    this.setState({ contractenddate: date });
  };

  validatepercentage = (values) => {
    let totalper = 0;
    values.map((e) => (totalper = e.percentage + totalper));
  };

  handlemilestonevalues = (values) => {
    let totalpercentage = 0;
    values.map((e) => {
      return (totalpercentage = e.percentage + totalpercentage);
    });
    if (totalpercentage > 100) {
      this.setState({ percentagemessage: "Percentage is Greaterthan 100%" });
    } else if (totalpercentage < 100) {
      this.setState({ percentagemessage: "Percentage is Lessthan 100%" });
    } else {
      this.setState({
        milestone: values,
        milestonesavebtn: true,
        percentagemessage: "Milestones Saved Scussesfully",
      });
    }
  };

  removeServiceFromList(id) {
    let deleteservice = serviceList.find((person, index) => index === id);
    let tp = deleteservice.servicetotal
    
    if(deleteservice.id !== undefined && deleteservice.id !== '' && deleteservice.id !== null){
      this.state.deletedservices.push(deleteservice?.id)
    }
    const newlist = serviceList.filter((person, index) => index !== id);
    this.setState({
      serviceList: newlist,
      grandservicetotal: this.state.grandservicetotal - tp,
    });
    serviceList = newlist;
  }

  handleaddService = () => {
    if (
      this.state.supplier === "" ||
      this.state.service === "" ||
      this.state.servicedescription === "" ||
      this.state.servicecost === "" ||
      this.state.servicecategory === ""
    ) {
      this.setState({ serviceerr: "Please fill all the Fields" });
    } else {
      let services = {
        service: this.state.service,
        description:this.state.servicedescription,
        serviceid: this.state.serviceid,
        contracttype: this.state.contracttype,
        recurringtype: this.state.contracttype === "Recurring" ? this.state.contracttime : "NotApplicable",
        recurrencetill: this.state.contracttype === "Recurring" ? this.state.contractstartdate : null,
        contractstartdate: this.state.contractstartdate,
        milestonequotation: this.state.contracttype === "Milestone" ? this.state.milestone : [],
        quantity: parseFloat(this.state.quantity),
        servicecatid: this.state.servicecatid,
        servicecode: this.state.servicecode,
        servicecategory: this.state.servicecategory,
        servicecost: parseFloat(this.state.servicecost),
        ccservicecost: parseFloat(this.state.servicecostconv),
        servicemarkup:this.state.servicemarkup?parseFloat(this.state.servicemarkup):0,
        ccservicemarkup:this.state.servicemarkupconv?parseFloat(this.state.servicemarkupconv):null,
        markup1:this.state.servicemarkup?parseFloat(this.state.servicemarkup):0,
        ccmarkup1:this.state.servicemarkupconv?parseFloat(this.state.servicemarkupconv):null,
        servicediscount:this.state.servicediscount,
        servicediscountamount:this.state.servicediscountamount?parseFloat(this.state.servicediscountamount):0,
        ccservicediscountamount:this.state.servicediscountamountconv?parseFloat(this.state.servicediscountamountconv):null,
        servicetax: this.state.servicetax,
        servicetaxamount:this.state.servicetaxamount * parseFloat(isInvalid.includes(this.state.curconversionrate)?1:this.state.curconversionrate),
        ccservicetaxamount:this.state.servicetaxamount?parseFloat(this.state.servicetaxamount):null,
        servicedescription: this.state.servicedescription,
        servicetotal:this.state.servicetotal?parseFloat(this.state.servicetotal):0,
        ccservicetotal:this.state.servicetotalconv?parseFloat(this.state.servicetotalconv):null,
        servicecostwttax: this.state.servicecostwttax?parseFloat(this.state.servicecostwttax):0,
        ccservicecostwttax:this.state.servicecostwttaxconv?parseFloat(this.state.servicecostwttaxconv):null,
        servicetotalwtax:this.state.servicecostwttax?parseFloat(this.state.servicecostwttax):0,
        ccservicetotalwtax:this.state.servicecostwttax?parseFloat(this.state.servicecostwttaxconv):null
      };
      serviceList.push(services);
      this.setState({
        serviceList: serviceList,
        grandservicetotal: this.state.grandservicetotal + parseFloat(this.state.servicecostwttax) ,
        ccgrandservicetotal:this.state.ccgrandservicetotal + parseFloat(this.state.servicecostwttaxconv),
        servicecost: 0,
        service: "",
        serviceerr: "",
        servicetax: 0,
        servicecode: "",
        servicedescription: "",
        servicecostconv: 0,
        servicetaxamount: 0,
        servicecgst: 0,
        servicesgst: 0,
        serviceigst: 0,
        servicegst: 0,
        servicevat: 0,
        servicecostwttax: 0,
        servicecostwttaxconv: 0,
      });
    }
  };

  handletaxrequired = () => {
    this.setState({ taxrequired: !this.state.taxrequired });
  };
  handleTaxtypeChange = (value, values)=>{
    this.setState({taxtype:values})
}
handleGsttypeChange = (value, values)=>{
    this.setState({gsttype:values})
}

  handleSoRecurringTimeChange = (e) => {
    this.setState({ sorecurringtime: e.target.value });
  };

  componentDidMount() {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }
    UserService.UserPermissions(userid).then((response) =>
      this.setState({ UserPermissions: response.data })
    );

    UsercustomerService.GetUserCustomersbyUser(userid).then((res) =>
      this.setState({
        usercustomers:
          res.data === "" || res.data === undefined
            ? []
            : res.data.customers.split(","),
      })
    );
    this.refreshData();
  }

  handleSliderChange = (event, newValue) => {
    this.setState({ paymentterms: newValue });
  };

  handlepaymentterms = (event) => {
    this.setState({ paymentterms: Number(event.target.value) });
  };

  handleBlur = () => {
    if (this.state.paymentterms < 0) {
      this.setState({ paymentterms: 0 });
    } else if (this.state.paymentterms > 120) {
      this.setState({ paymentterms: 120 });
    }
  };

  handleAdvanceAmountChange = (e) => {
    this.setState({
      advance: Number(e.target.value),
      advancecnvt:Number(e.target.value) / this.state.curconversionrate,
    });
  };

  handleAdvanceAmountcnvtChange = (e) => {
    this.setState({
      advancecnvt:Number(e.target.value),
      advance:Number(e.target.value) * this.state.curconversionrate,
    });
  };

  handleAdvanceAmountBlur = () => {
    if (this.state.advance < 0) {
      this.setState({ advance: 0 });
    } else if (this.state.advance > this.state.grandtotal) {
      this.setState({ advance: this.state.grandtotal });
    }
  };

  validate(values) {
    let errors = {};

    if (this.state.customer === "") {
      errors.customer = "Please Select Customer";
    }

    if (this.state.whid === "") {
      errors.warehouse = "Please Select Org Unit";
    }

    if(this.state.salestype === "1"){

    }else{

    if (this.state.quantity === "" || this.state.quantity === null) {
      errors.quantity = "Please Enter Quantity";
    }
    if (this.state.quantity <= 0) {
      errors.quantity = "Value Should be greaterthan 0";
    }

    if(this.state.cost === "" || this.state.cost === null ){
      errors.cost = "Please enter Price";
    }

    if (this.state.category === "") {
      errors.category = "Please Select Category";
    }
    if (this.state.description === "") {
      errors.description = "Please Enter Description";
    }

    if (this.state.itemname === "") {
      errors.itemname = "Please Select Item";
    }
  }
    return errors;
  }

  onfocus() {
    document
      .getElementById("quantity")
      .addEventListener("mousewheel", function (event) {
        if (window.document.activeElement.type === "number") {
          event.preventDefault();
        }
      });
    document
      .getElementById("quantity")
      .addEventListener("keydown", function (e) {
        if (e.which === 38 || e.which === 40) {
          e.preventDefault();
        }
      });
  }

  oncostfocus() {
    document
      .getElementById("cost")
      .addEventListener("mousewheel", function (event) {
        if (window.document.activeElement.type === "number") {
          event.preventDefault();
        }
      });
    document.getElementById("cost").addEventListener("keydown", function (e) {
      if (e.which === 38 || e.which === 40) {
        e.preventDefault();
      }
    });
  }

  onamountfocus() {
    document
      .getElementById("amount")
      .addEventListener("mousewheel", function (event) {
        if (window.document.activeElement.type === "number") {
          event.preventDefault();
        }
      });
    document.getElementById("amount").addEventListener("keydown", function (e) {
      if (e.which === 38 || e.which === 40) {
        e.preventDefault();
      }
    });
  }

  oncurrencyconvtfocus() {
    document
      .getElementById("standard-adornment-amount")
      .addEventListener("mousewheel", function (event) {
        if (window.document.activeElement.type === "number") {
          event.preventDefault();
        }
      });
    document
      .getElementById("standard-adornment-amount")
      .addEventListener("keydown", function (e) {
        if (e.which === 38 || e.which === 40) {
          e.preventDefault();
        }
      });
  }

  onpricevariancefocus() {
    document
      .getElementById("pricevariance")
      .addEventListener("mousewheel", function (event) {
        if (window.document.activeElement.type === "number") {
          event.preventDefault();
        }
      });
    document
      .getElementById("pricevariance")
      .addEventListener("keydown", function (e) {
        if (e.which === 38 || e.which === 40) {
          e.preventDefault();
        }
      });
  }

  render() {
    let {
      ordertype,
      id,
      soid,
      salestype,
      agentsdata,
      agentreq,
      agent,
      agentid,
      itemid,
      itemname,
      cost,
      type,
      hsn,
      hsnid,
      stock,
      quantity,
      pricevariance,
      totalpricewtax,
      tax,
      customer,
      custom,
      custid,
      gsttype,
      itemList,
      cgst,
      sgst,
      UOMList,
      sizelist,
      colourlist,
      thicknesslist,
      brandslist,
      saleorderdata,
      preitemList,
      additionalparams,
      size,
      brand,
      model,
      colour,
      totalmtrroll,
      thicknes,
      description,
      filteritemlist,
      WarehouseList,
      DepartmentList,
      deptid,
      department,
      warehouse,
      whid,
      CategoryList,
      catid,
      category,
      uom,
      uomid,
      advance,
      advancecnvt,
      advancestatus,
      paymentterms,
      filterserv,
      serviceitemList,
      serviceList,
      service,
      serviceid,
      ServiceCategoryList,
      servicecategory,
      servicecatid,
      servicetax,
      servicecode,
      servicecost,
      servicecostconv,
      servicecgst,
      servicesgst,
      serviceigst,
      servicegst,
      servicevat,
      servicecostwttax,
      servicecostwttaxconv,
      servicetaxamount,
      servicedescription,
      servicetotal,
      grandservicetotal,
      serviceerr,
      contracttype,
      contracttypeList,
      recurringtype,
      contracttime,
      currencylist,
      convertionreq,
      currencyid,
      currency,
      curconversionrate,
      basecurrency,
    } = this.state;

    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={this.state.sloader}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

          <div className="UI-container">
          <div className="UI-header">
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/sales"},{name:"Quotations",path:"/quotation"},{name:this.state.pagename,path:null}]}/>
          </div>
            <div className="UI-form-card">
              <Formik
                initialValues={{
                  ordertype,
                  id,
                  salestype,
                  soid,
                  agentsdata,
                  agentreq,
                  agent,
                  agentid,
                  itemid,
                  itemname,
                  filteritemlist,
                  WarehouseList,
                  warehouse,
                  whid,
                  DepartmentList,
                  deptid,
                  department,
                  CategoryList,
                  category,
                  catid,
                  hsn,
                  hsnid,
                  cost,
                  type,
                  stock,
                  quantity,
                  pricevariance,
                  tax,
                  cgst,
                  sgst,
                  totalpricewtax,
                  custid,
                  customer,
                  gsttype,
                  custom,
                  itemList,
                  UOMList,
                  uom,
                  uomid,
                  sizelist,
                  colourlist,
                  thicknesslist,
                  brandslist,
                  saleorderdata,
                  preitemList,
                  additionalparams,
                  size,
                  brand,
                  model,
                  colour,
                  totalmtrroll,
                  thicknes,
                  description,

                  advance,
                  advancecnvt,
                  advancestatus,
                  paymentterms,
                  filterserv,
                  serviceitemList,
                  serviceList,
                  service,
                  serviceid,
                  ServiceCategoryList,
                  servicecategory,
                  servicecatid,
                  servicetax,
                  servicecode,
                  servicecost,
                  servicecostconv,
                  servicecgst,
                  servicesgst,
                  serviceigst,
                  servicegst,
                  servicevat,
                  servicecostwttax,
                  servicecostwttaxconv,
                  servicetaxamount,
                  servicedescription,
                  servicetotal,
                  grandservicetotal,
                  serviceerr,
                  contracttype,
                  contracttypeList,
                  recurringtype,
                  contracttime,
                  currencylist,
                  convertionreq,
                  currencyid,
                  currency,
                  curconversionrate,
                  basecurrency,
                  milestone: [
                    {
                      name: "",
                      expecteddate1: "",
                      percentage: 0,
                      amount: 0,
                      amountwttax: 0,
                    },
                  ],
                }}
                onSubmit={this.onSubmit}
                validateOnChange={false}
                validate={this.validate}
                enableReinitialize={true}
              >
                {({ setFieldValue, values,errors,validateForm }) => (
                  <Form autoComplete="off">
                    <div className="form-row">
                      <fieldset hidden className="form-group col-md-6">
                        <label>Id</label>
                        <Field
                          className="form-control"
                          type="text"
                          name="itemid"
                          placeholder="Id"
                        />
                      </fieldset>
                      {this.state.id === -1 &&
                      (custom === undefined ||
                        custom.length === 0 ||
                        CategoryList === undefined ||
                        CategoryList.length === 0) ? (
                        <fieldset className="form-group col-md-12 deletebg">
                          <ul className="py-3 text-center text-xs">
                            {/* <li style={{ "list-style": "none" }}>Note:</li> */}
                            {custom === undefined || custom.length === 0 ? (
                              <li>No Customers are Available.</li>
                            ) : (
                              ""
                            )}
                            {CategoryList === undefined ||
                            CategoryList.length === 0 ? (
                              <li>No Items are Available.</li>
                            ) : (
                              ""
                            )}
                          </ul>
                        </fieldset>
                      ) : (
                        ""
                      )}

                      {this.state.pagename === "Edit/Updated Quotation" ? (
                        ""
                      ) : (
                        <fieldset className="form-group col-md-12 p-0 m-0">
                          <div className="form-row p-0 m-0">
                            {this.state.settings.salesservice === "NO" &&
                            this.state.settings.salespands === "NO" ? (
                              ""
                            ) : (
                              <fieldset className="form-group col-md-12 p-0">
                                  {/* <h3 className="UI-section-title" style={{ backgroundColor: '#f4f4f4', padding: '12px' }}>
                                                                        Add invoice information
                                                                    </h3> */}
                                  <div
                                    className="UI-form-grid"
                                    style={{
                                      gridTemplateColumns:
                                        "repeat(auto-fit, minmax(200px, 1fr))",
                                      gap: "16px",
                                    }}
                                  >
                                    <RectangularTabButton label={"Only Products"} checked={this.state.pro} onClick={()=>this.handleProductChange(true,false,false)} icon={BoxIcon}/>
                                    {this.state.settings.salesservice === "YES" && ( <RectangularTabButton label={"Only Services"} checked={this.state.serv} onClick={()=>this.handleProductChange(false,true,false)} icon={WrenchIcon}/>)}
                                    {this.state.settings.salespands === "YES" && ( <RectangularTabButton label={"Products & Services"} checked={this.state.prosev} onClick={()=>this.handleProductChange(false,false,true)} icon={BoxesIcon}/>)}
                                  </div>
</fieldset>
                            )}
                          </div>
                        </fieldset>
                      )}
                      <div className="row form-group col-md-12 tw-border tw-border-dotted tw-rounded-[10px] tw-mb-5 tw-pb-3 mx-0 px-2 tw-group hover:tw-border-[#e4f0f7]" >
                      <div className="col-md-12 m-0 p-0 " >
                      <div className="tw-flex tw-items-center UI-section-title tw-p-3 tw-gap-2">
                        <div className={`tw-w-7 tw-h-7 tw-rounded-xl ${theme === 'classic' ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : ' tw-bg-sky-50 tw-text-sky-600'} tw-flex tw-items-center tw-justify-center tw-shrink-0`}>
                                          <Users size={14} />
                                        </div>
                                        <h3 className=" ">Customer and Order Details</h3>
                                        </div> 
                      </div>
                      <fieldset className=" col-md-3 ">
                      <AutoCompeteField id="customer" name="customer" type="text" options={custom} valueKey={"companyname"} labelKey={"companyname"} value={this.state.customer} label={`Select Customer`} required placeholder="" onChange={this.handleCustomer} disabled={this.state.grandtotal!==0 } error={errors?.customer} />
                      </fieldset>
                      <fieldset className=" col-md-3 ">
                      <AutoCompeteField id="agent" name="agent" type="text" options={agentsdata} valueKey={"name"} labelKey={"name"} value={this.state.agent} label={`Select Agent`} placeholder="" onChange={this.handleAgent} disabled={ this.state.grandtotal > 0}/>
                      </fieldset>
                      <fieldset className="col-md-3">
                      <AutoCompeteField id="warehouse" name="warehouse" type="text" options={WarehouseList} valueKey={"name"} labelKey={"name"} value={this.state.warehouse} label={`Select Org Unit`} placeholder="" onChange={this.handleWarehouse} disabled={ this.state.grandtotal > 0 } required error={errors?.warehouse}/>
                      </fieldset>
                      <fieldset className="col-md-3">
                      <div style={{ display: 'grid', gridTemplateColumns: 'auto auto auto', alignItems: 'center', gap: '12px' }}>
                                                                <div style={{ display: 'flex', flexDirection: 'column' }} className="tw-pb-1">
                                                                    <label className="UI-label" >Order Currency</label>
                                                                    <Autocomplete
                                                                        id="currency"
                                                                        name="currency"
                                                                        options={currencylist}
                                                                        getOptionLabel={(option) => option.currency}
                                                                        value={this.state.currency ? currencylist.find(e => e.currency === this.state.currency) : null}
                                                                        onChange={this.handleCurrency}
                                                                        disabled={!isInvalid.includes(this.state.grandtotal) || !isInvalid.includes(this.state.grandservicetotal) || this.state.orderfrom === 1 || !isInvalid.includes(this.state.saleorderid)}
                                                                        renderInput={(params) => (
                                                                            <div ref={params.InputProps.ref} style={{ position: 'relative', width: '150px' }}>
                                                                                <input
                                                                                    type="text"
                                                                                    {...params.inputProps}
                                                                                    className="UI-input"
                                                                                    placeholder="Order Currency"
                                                                                    value={this.state.currency}
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        paddingRight: this.state.currency && this.state.currency !== this.state.basecurrency ? '30px' : undefined
                                                                                    }}
                                                                                />
                                                                                {this.state.currency && this.state.currency !== this.state.basecurrency && (
                                                                                    <span
                                                                                        style={{
                                                                                            position: 'absolute',
                                                                                            right: '10px',
                                                                                            top: '50%',
                                                                                            transform: 'translateY(-50%)',
                                                                                            pointerEvents: 'none',
                                                                                            fontSize: '13px',
                                                                                            color: '#666'
                                                                                        }}
                                                                                    >
                                                                                        1
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    />
                                                                </div>

                                                                {/* Equals sign column - only shown when currencies differ */}
                                                                {this.state.currency !== this.state.basecurrency && (
                                                                    <div style={{ alignSelf: 'center', marginTop: '20px' /* offset to ignore the label space */ }}>
                                                                        <span style={{ fontSize: '16px', fontWeight: 500, lineHeight: 1 }}>=</span>
                                                                    </div>
                                                                )}

                                                                {/* Third column: Conversion Rate (only shown when currencies differ) */}
                                                                {this.state.currency !== this.state.basecurrency && (
                                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                        <label className="UI-label" >Conversion Rate</label>
                                                                        <div style={{ position: 'relative',width: '150px'}}>
                                                                            <input
                                                                                type="number"
                                                                                className="UI-input"
                                                                                value={this.state.curconversionrate}
                                                                                onChange={(e) => this.setState({ curconversionrate: e.target.value }, this.recomputeTotals)}
                                                                                disabled={!isInvalid.includes(this.state.grandtotal) || !isInvalid.includes(this.state.grandservicetotal) || this.state.orderfrom === 1 || !isInvalid.includes(this.state.saleorderid)}
                                                                                style={{
                                                                                    width: '100%',
                                                                                    paddingRight: '55px'
                                                                                }}
                                                                            />
                                                                            <span
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    right: '12px',
                                                                                    top: '50%',
                                                                                    transform: 'translateY(-50%)',
                                                                                    pointerEvents: 'none',
                                                                                    fontSize: '13px',
                                                                                    color: '#666'
                                                                                }}
                                                                            >
                                                                                {this.state.basecurrency}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            </fieldset>
                      {/* <fieldset className="form-group col-md-2 mb-4">

<Autocomplete
                        id="subaccount"
                        className="subacc-select"
                        name="currency"
                        options={currencylist}
                        getOptionLabel={(option) => option.currency}
                        value={this.state.currency?currencylist.find(e=>e.currency === this.state.currency):null}
                        onChange={this.handleCurrency}
                        disabled={!isInvalid.includes(this.state.grandtotal) || !isInvalid.includes(this.state.grandservicetotal) || this.state.orderfrom === 1}
                        renderInput={(params) => (
                          <FormikTextField
                            {...params}
                            className="form-control"
                            type="text"
                            name="currency"
                            value={this.state.currency}
                            label={`Select Order Currency (${this.state.currency})`}
                            variant="standard"
                            fullWidth
                          />
                        )}
                        />
                        </fieldset>
                        {this.state.currency === this.state.basecurrency|| this.state.currency === undefined || this.state.currency === ''?'':
<fieldset className="form-group col-md-2" >

<FormControl fullWidth variant="standard">
          <InputLabel htmlFor="standard-adornment-amount">{`Enter Conversion rate`}</InputLabel>
          <Input
            id="standard-adornment-amount"
            value={this.state.curconversionrate}
            type="number"
            onChange={this.handleCurconversionrate}
            onFocus={this.oncurrencyconvtfocus}
            startAdornment={<InputAdornment position="start">1 {this.state.currency} =</InputAdornment>}
            endAdornment={<InputAdornment position="end"> {this.state.basecurrency}</InputAdornment>}
            disabled = {this.state.grandtotal !== 0 || this.state.grandservicetotal !== 0 || this.state.orderfrom===1 }
          />
</FormControl>
</fieldset>
} */}
<div className="form-group col-md-12 m-0 p-0" >
<div style={{ display: 'flex', gap: '25px', alignItems: 'flex-start', flexShrink: 0 }}>
    <RoundedTabButton label={"With Tax"}  checked={this.state.taxrequired} onClick={() =>this.setState((prev) => ({taxrequired: !prev.taxrequired}))} className="tw-mt-4 "/>
                                                {this.state.taxrequired === true && <>
                                                            <div className="UI-form-group" style={{ minWidth: '120px', marginLeft: '12px', flexShrink: 1 }}>
                                                                <label className="UI-label">Tax type</label>
                                                                {/* <input
                                                                    type="text"
                                                                    className="UI-input UI-input-disabled"
                                                                    value={this.state.taxtype}
                                                                    disabled
                                                                /> */}
                                                                <Autocomplete
                                                                        id="currency"
                                                                        name="currency"
                                                                        options={this.state.taxtypelist}
                                                                        getOptionLabel={(option) => option}
                                                                        value={this.state.taxtype}
                                                                        onChange={this.handleTaxtypeChange}
                                                                        disabled={!isInvalid.includes(this.state.grandtotal) || !isInvalid.includes(this.state.grandservicetotal) || this.state.orderfrom === 1 || !isInvalid.includes(this.state.saleorderid)}
                                                                        renderInput={(params) => (
                                                                            <div ref={params.InputProps.ref} style={{ position: 'relative', width: '200px' }}>
                                                                                <input
                                                                                    type="text"
                                                                                    {...params.inputProps}
                                                                                    className="UI-input"
                                                                                    placeholder="Select Taxtype"
                                                                                    value={this.state.taxtype}
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        // paddingRight: this.state.currency && this.state.currency !== this.state.basecurrency ? '30px' : undefined
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    />
                                                            </div>
                                                            {ccountry === "India" && this.state.taxtype === "GST" && 
                                                            <div className="UI-form-group" style={{ minWidth: '120px', marginLeft: '12px', flexShrink: 1 }}>
                                                            <label className="UI-label">GST Type</label>
                                                            {/* <input
                                                                type="text"
                                                                className="UI-input UI-input-disabled"
                                                                value={this.state.taxtype}
                                                                disabled
                                                            /> */}
                                                            <Autocomplete
                                                                    id="currency"
                                                                    name="currency"
                                                                    options={this.state.gsttypelist}
                                                                    getOptionLabel={(option) => option}
                                                                    value={this.state.gsttype}
                                                                    onChange={this.handleGsttypeChange}
                                                                    disabled={!isInvalid.includes(this.state.grandtotal) || !isInvalid.includes(this.state.grandservicetotal) || this.state.orderfrom === 1 || !isInvalid.includes(this.state.saleorderid)}
                                                                    renderInput={(params) => (
                                                                        <div ref={params.InputProps.ref} style={{ position: 'relative', width: '200px' }}>
                                                                            <input
                                                                                type="text"
                                                                                {...params.inputProps}
                                                                                className="UI-input"
                                                                                placeholder="Select Taxtype"
                                                                                value={this.state.gsttype}
                                                                                style={{
                                                                                    width: '100%',
                                                                                    // paddingRight: this.state.currency && this.state.currency !== this.state.basecurrency ? '30px' : undefined
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                />
                                                            </div>}
                                                            </>
                                                        }
{/* {this.state.taxrequired === true && (
                    <fieldset className="form-group col-md-3 m-0">
                    <TextField
                      className="form-control"
                      type="text"
                      name="creditperiod"
                      value={`${this.state.taxtype}${this.state.taxtype==="GST"?this.state.gsttype === "INTRASTATE"?' - Intra State (With in the State)':' - Inter State (Outside the State)':""}`}
                      label={`Tax Type`}
                      variant="standard"
                      disabled
                      fullwidth="true"
                    />
                  </fieldset>
                )} */}
                </div>
</div>
                        </div>
                    
                      
                      {this.state.salestype === "1" ? (
                        ""
                      ) : (
                        <div className="form-row col-md-12 tw-border tw-border-dotted tw-rounded-[10px] tw-mb-5 tw-pb-3 mx-0 px-0 tw-group">
                          {/* <h3 className="UI-section-title tw-w-full tw-bg-[#f4f4f4] group-hover:tw-bg-[#e4f0f7] tw-p-3">Product Details</h3> */}
                           <div className="tw-flex tw-items-center UI-section-title tw-p-3 tw-gap-2 col-md-12">
                        <div className={`tw-w-7 tw-h-7 tw-rounded-xl ${theme === 'classic' ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : ' tw-bg-sky-50 tw-text-sky-600'} tw-flex tw-items-center tw-justify-center tw-shrink-0`}>
                                          <BoxIcon size={14} />
                                        </div>
                                        <h3 className=" ">Product Details</h3>
                                        </div> 
                          <fieldset className="form-group col-md-3">
                            <AutoCompeteField id="department" name="department" type="text" options={DepartmentList} valueKey={"name"} labelKey={"name"} value={this.state.department} label={`Select Department`} placeholder="" onChange={this.handleDepartment} disabled={this.state.grandtotal > 0} error={errors?.department}/>
                          </fieldset>
                              <fieldset className="form-group col-md-3">
                              <AutoCompeteField id="category" name="category" type="text" options={CategoryList} valueKey={"category"} labelKey={"category"} value={this.state.category} label={`Select Category`} placeholder="" onChange={this.handleCategory} disabled={this.state.ordertype} error={errors?.category}/>
                              </fieldset>

                              <fieldset className="form-group col-md-3 ">
                              <AutoCompeteField id="itemname" name="itemname" type="text" options={filteritemlist} valueKey={"name"} labelKey={"label"} value={this.state.itemname} label={`Select Item/Product`} placeholder="" onChange={this.handleitem} disabled={this.state.ordertype} required error={errors?.["itemname"]}/>
                              </fieldset>
                          <fieldset className="form-group col-md-3">
                            <TextfieldComponent id={"cost"} name={"cost"} type={"number"} label={"Price"} value={this.state.cost} onChange={(e) =>this.setState({cost:e.target.value === undefined? 0: e.target.value,totalpricewtax: ""})} disabled={this.state.orderfrom === 1 || this.state.settings.soeditprice === "NO"} prefix={this.state.currency} required error={errors?.cost} />
                          </fieldset>
                          {this.state.settings.allowextramakup ==="YES"?
                          <fieldset className="form-group col-md-3">
                            <TextfieldComponent id={"markup1"} name={"markup1"} type={"number"} label={"Extra Markup"} value={this.state.markup1} onChange={this.handlemarkup1Change} disabled={this.state.orderfrom === 1 || this.state.settings.soeditprice === "NO"} prefix={this.state.currency} />
                        </fieldset>
                        :""}
                         {/* <fieldset className="form-group col-md-3">
                          <FormikTextField
                            id="discount"
                            className="form-control"
                            type="number"
                            name="discount"
                            label={"Discount (%)"}
                            min="0"
                            value={this.state.discount}
                            onChange={this.handleDiscountChange}
                            onFocus={this.ondiscountfocus}
                            InputProps={{
                              endAdornment: <InputAdornment position="end">%</InputAdornment>,
                            }}
                          />
                        </fieldset> */}

                          {this.state.salescalreq === "YES" &&
                          this.state.settings.soeditprice === "YES" ? (
                            <fieldset className="form-group col-md-3">
                              <SelectField label={"Type"} lableKey={"label"} lableValue={"value"} list={[{value:"Average",label:`Average ${this.state.avgprice?`(${this.state.basecurrency} ${this.state.avgprice})`:""} ${this.state.currency!==this.state.basecurrency && this.state.avgprice ?`(${this.state.currency} ${(this.state.avgprice/this.state.curconversionrate).toFixed(3) })`:"" }`},{value:"FIFO",label:`FIFO ${this.state.fifoprice?`(${this.state.basecurrency} ${this.state.fifoprice})`:""} ${this.state.currency!==this.state.basecurrency && this.state.fifoprice?`(${this.state.currency} ${(this.state.fifoprice/this.state.curconversionrate).toFixed(3) })`:"" }`},{value:"LIFO",label:`LIFO ${this.state.lifoprice?`(${this.state.basecurrency} ${this.state.lifoprice})`:""} ${this.state.currency!==this.state.basecurrency && this.state.lifoprice?`(${this.state.currency} ${(this.state.lifoprice/this.state.curconversionrate).toFixed(3) })`:"" }`}]} value={this.state.type} onChange={this.handleTypeChange}/>
                            </fieldset>
                          ) : (
                            ""
                          )}

                          <fieldset className="form-group col-md-3">
                          <TextfieldComponent id={"quantity"} name={"quantity"} type={"number"} label={"Quantity"} value={this.state.quantity} onChange={(e) =>this.setState({quantity: e.target.value,availabelcredit: this.state.creditvalue,})} prefix={this.state.uom} required error={errors?.quantity} />
                          </fieldset>
                          {this.state.basecurrency !== this.state.currency && ( <fieldset className="form-group col-md-3">
                            <TextfieldComponent id={"pricevariance"} name={"pricevariance"} type={"number"} label={"Price Variance"} value={this.state.pricevariance} onChange={(e) =>this.setState({pricevariance: e.target.value})} prefix={"%"} />
                            </fieldset>
                          )}
                          {this.state.taxrequired === true ? (
                            <>
                              <fieldset className="form-group col-md-3">
                                <SelectField id="tax" label={`Select Tax(%)`} list={[{ tax: "", description: "Select tax" }, ...this.state.taxesList.map((e => { return { ...e, description: e.tax } }))]} lableKey={"description"} lableValue={"tax"} name="tax" value={this.state.tax} onChange={(e) => this.setState({ tax: e.target.value, cgst: e.target.value / 2, sgst: e.target.value / 2, igst: e.target.value, vat: e.target.value })} />
                              </fieldset>
                              <fieldset className="form-group col-md-3">
                              <TextfieldComponent id="hsn" label={`${taxtype==="VAT"?"Item Code":" HSN Code"}`} type={"text"} name="hsn" disabled value={this.state.hsn} />
                              </fieldset>

                              <>
                             {this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE" ?
                              <fieldset className="tw-flex tw-gap-1 col-md-3">
                              <TextfieldComponent id="cgst" label={`CGST`} type={"text"} name="cgst" disabled value={this.state.cgst} prefix={"%"} />
                              <TextfieldComponent id="cgst" label={`SGST`} type={"text"} name="sgst" disabled value={this.state.sgst} prefix={"%"} />
                              </fieldset>:
                              <fieldset className=" col-md-3">
                              <TextfieldComponent id={this.state.taxtype === "GST"? ccountry === "India" ?"igst":"gst":"vat"} label={this.state.taxtype === "GST"? ccountry === "India" ?"IGST":"GST":"VAT"} type={"text"} name={this.state.taxtype === "GST"? ccountry === "India" ?"igst":"gst":"vat"} disabled value={this.state.igst} prefix={"%"}/>
                              </fieldset>}
                            </>

                              {/* {this.state.taxtype === "GST" &&
                              ccountry === "India" ? (
                                this.state.gsttype === "INTRASTATE" ? (
                                  <>
                                    <fieldset className="form-group col-md-3">
                                      <FormikTextField
                                        className="form-control"
                                        type="number"
                                        name="cgst"
                                        value={this.state.tax / 2}
                                        label="CGST (%)"
                                        variant="standard"
                                        fullWidth
                                        disabled
                                      />
                                    </fieldset>
                                    <fieldset className="form-group col-md-3">
                                      <FormikTextField
                                        className="form-control"
                                        type="number"
                                        name="sgst"
                                        value={this.state.tax / 2}
                                        label="SGST (%)"
                                        variant="standard"
                                        fullWidth
                                        disabled
                                      />
                                    </fieldset>
                                  </>
                                ) : (
                                  <>
                                    <fieldset className="form-group col-md-3">
                                      <FormikTextField
                                        className="form-control"
                                        type="number"
                                        name="tax"
                                        value={this.state.tax}
                                        label="IGST (%)"
                                        variant="standard"
                                        fullWidth
                                        disabled
                                      />
                                    </fieldset>
                                  </>
                                )
                              ) : (
                                <>
                                  {this.state.taxtype === "GST" ? (
                                    <fieldset className="form-group col-md-3">
                                      <FormikTextField
                                        className="form-control"
                                        type="number"
                                        name="tax"
                                        value={this.state.tax}
                                        label="GST (%)"
                                        variant="standard"
                                        fullWidth
                                        disabled
                                      />
                                    </fieldset>
                                  ) : (
                                    <fieldset className="form-group col-md-3">
                                      <FormikTextField
                                        className="form-control"
                                        type="number"
                                        name="vat"
                                        label="VAT (%)"
                                        value={this.state.tax}
                                        min="0"
                                        disabled
                                      />
                                    </fieldset>
                                  )}
                                </>
                              )} */}
                            </>
                          ) : (
                            ""
                          )}
                          <fieldset className="form-group col-md-3 ">
                          <TextfieldComponent id="brand" label={`Brand`} type={"text"} name="brand" disabled value={this.state.brand} />
                          </fieldset>

                          <fieldset className="form-group col-md-3 ">
                          <TextfieldComponent id="model" label={`Model`} type={"text"} name="model" disabled value={this.state.model} />
                          </fieldset>

                          {this.state.additionalparams === 0 ? (
                            ""
                          ) : (
                            <>
                              <fieldset className="form-group col-md-3">
                              <AutoCompeteField id="size" name="size" type="text" options={sizelist} valueKey={null} labelKey={null} value={this.state.size} label={`Select Size`} placeholder="" onChange={this.handleSize}/>
                              </fieldset>

                              <fieldset className="form-group col-md-3">
                              <AutoCompeteField id="colour" name="colour" type="text" options={colourlist} valueKey={null} labelKey={null} value={this.state.colour} label={`Select Colour`} placeholder="" onChange={this.handleColour}/>
                              </fieldset>
                              <fieldset className=" col-md-3 ">
                          <TextfieldComponent id="thickness" label={`Thikness`} type={"text"} name="thickness" value={this.state.thickness} onChange={(e) =>this.setState({ thickness: e.target.value })}/>
                          </fieldset>

                          <fieldset className=" col-md-3 ">
                          <TextfieldComponent id="totalmtrroll" label={`TotalMtrRoll`} type={"text"} name="totalmtrroll" value={this.state.totalmtrroll} onChange={(e) =>this.setState({ totalmtrroll: e.target.value })}/>
                          </fieldset>
                        </>)}
                        <fieldset className=" col-md-12  my-1">
                          <TextareaField name="description" className="form-control" multiline rows={1} label="Description/Specifications" value={this.state.description}
                            onChange={(e) => this.setState({ description: e.target.value })} maxLength={200}
                          />
                        </fieldset>
                          {/* </div> */}

                          {/* <div className="form-group col-md-12" /> */}

                          {/* <fieldset className="form-group col-md-12 mt-1" /> */}
                            
                            {this.state.totalpricewtax === "" || this.state.totalpricewtax === null || this.state.totalpricewtax === 0?"":
                          <fieldset className="form-group col-md-4 text-sm">
                            <>Total Price</>
                            <>
                              &nbsp; : &nbsp;
                              <NumericFormat
                                displayType={"text"}
                                value={
                                  this.state.totalpricewtax === ""
                                    ? 0
                                    : this.state.totalpricewtax
                                }
                                decimalScale={2}
                                fixedDecimalScale={true}
                                disabled={true}
                                thousandSeparator={true}
                                thousandsGroupStyle={thousandsdisplay}
                              ></NumericFormat>
                            </>
                          </fieldset>}

                          {this.state.creditstatus === "Required" ? (
                            <>
                              <fieldset className="form-group col-md-4 text-sm">
                                <>Available Credit&nbsp;:&nbsp;</>
                                <>
                                  <NumericFormat
                                    displayType={"text"}
                                    value={
                                      this.state.availabelcredit === "" ||
                                      this.state.availabelcredit === undefined
                                        ? 0
                                        : this.state.availabelcredit
                                    }
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    disabled={true}
                                    thousandSeparator={true}
                                    thousandsGroupStyle={thousandsdisplay}
                                  ></NumericFormat>
                                </>
                              </fieldset>
                              <fieldset className="form-group col-md-4 text-sm">
                                <>Credit Value&nbsp;:&nbsp;</>
                                <>
                                  <NumericFormat
                                    displayType={"text"}
                                    value={
                                      this.state.initialCredit === "" ||
                                      this.state.initialCredit === undefined
                                        ? 0
                                        : this.state.initialCredit
                                    }
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    disabled={true}
                                    thousandSeparator={true}
                                    thousandsGroupStyle={thousandsdisplay}
                                  ></NumericFormat>
                                </>
                              </fieldset>
                              {/* <fieldset className="form-group col-md-3">
                                <>Credit Period</>
                                <>
                                  &nbsp; : &nbsp;{" "}
                                  {this.state.creditperiod === ""
                                    ? "0"
                                    : this.state.creditperiod}{" "}
                                  days
                                </>
                              </fieldset> */}
                            </>
                          ) : (
                            ""
                          )}

                          <div className="form-group col-md-12 m-0 p-0" />

                          {this.state.availabelcredit < 0 ? (
                            <>
                              <p className="text-red">
                                Execeded Credit Value, Requsest for credit
                              </p>

                              <button
                                className="btn btn-sm hovbuttonColour"
                                onClick={this.handleRequestCredit}
                                type="button"
                              >
                                Request Credit Value
                              </button>
                            </>
                          ) : (
                            <div className="tw-flex tw-justify-end tw-w-full">
                                <button
                                  className="btn btn-sm hovbuttonColour tw-m-2"
                                  type="submit"
                                >
                                  Add Item
                                </button>
                            </div>
                          )}

                          <div className="form-group col-md-12" />
                          {this.state.grandtotal === 0 || "" ? (
                            ""
                          ) : (
                            <>
                              <TableContainer>
                                <Typography> <h3 className="UI-section-title tw-w-full tw-bg-[#f4f4f4] tw-p-3 mb-0">Products List</h3> </Typography>
                                <Table className="table-sm">
                                  <TableHead>
                                    <TableRow className="text-center">
                                      <TableCell></TableCell>
                                      <TableCell className="text-center">
                                        Itemname
                                      </TableCell>
                                      {this.state.taxrequired === true ? (
                                        <TableCell className="text-center">
                                          HSN Code
                                        </TableCell>
                                      ) : (
                                        ""
                                      )}
                                      <TableCell className="text-center">
                                        Price
                                      </TableCell>
                                      {this.state.currency ===
                                      this.state.basecurrency ? (
                                        ""
                                      ) : (
                                        <TableCell className="text-center">
                                          Price({this.state.currency})
                                        </TableCell>
                                      )}
                                      {this.state.currency ===
                                      this.state.basecurrency ? (
                                        ""
                                      ) : (
                                        <TableCell className="text-center">
                                          Pricevariance (%)
                                        </TableCell>
                                      )}
                                      {/* <TableCell className="text-center">
                                        Sales Type
                                      </TableCell> */}
                                      <TableCell className="text-center">
                                        Quantity
                                      </TableCell>
                                      <TableCell className="text-center">
                                        UOM
                                      </TableCell>
                                      <TableCell className="text-center">
                                        Total{" "}
                                      </TableCell>
                                      {this.state.currency ===
                                      this.state.basecurrency ? (
                                        ""
                                      ) : (
                                        <TableCell className="text-center">
                                          Total ({this.state.currency})
                                        </TableCell>
                                      )}
                                      {this.state.taxrequired === true ? (
                                        <>
                                          {this.state.taxtype === "GST" &&
                                          ccountry === "India" ? (
                                            this.state.gsttype === "INTRASTATE" ? (
                                              <>
                                                <TableCell className="text-center">
                                                  CGST
                                                </TableCell>
                                                <TableCell className="text-center">
                                                  SGST
                                                </TableCell>
                                                {this.state.currency ===
                                                this.state.basecurrency ? (
                                                  ""
                                                ) : (
                                                  <>
                                                    {" "}
                                                    <TableCell className="text-center">
                                                      CGST({this.state.currency}
                                                      )
                                                    </TableCell>
                                                    <TableCell className="text-center">
                                                      SGST({this.state.currency}
                                                      )
                                                    </TableCell>
                                                  </>
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                <TableCell className="text-center">
                                                  IGST
                                                </TableCell>
                                                {this.state.currency ===
                                                this.state.basecurrency ? (
                                                  ""
                                                ) : (
                                                  <TableCell className="text-center">
                                                    IGST({this.state.currency})
                                                  </TableCell>
                                                )}
                                              </>
                                            )
                                          ) : this.state.taxtype === "GST" ? (
                                            <>
                                              <TableCell className="text-center">
                                                GST
                                              </TableCell>
                                              {this.state.currency ===
                                              this.state.basecurrency ? (
                                                ""
                                              ) : (
                                                <TableCell className="text-center">
                                                  GST({this.state.currency})
                                                </TableCell>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {" "}
                                              <TableCell className="text-center">
                                                VAT
                                              </TableCell>
                                              {this.state.currency ===
                                              this.state.basecurrency ? (
                                                ""
                                              ) : (
                                                <TableCell className="text-center">
                                                  VAT({this.state.currency})
                                                </TableCell>
                                              )}
                                            </>
                                          )}
                                          <TableCell className="text-center">
                                            Total Price
                                          </TableCell>
                                          {this.state.currency ===
                                          this.state.basecurrency ? (
                                            ""
                                          ) : (
                                            <TableCell className="text-center">
                                              Total Price({this.state.currency})
                                            </TableCell>
                                          )}
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      <TableCell className="text-center">
                                        Action
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {this.state.listData.map((data, index) => (
                                      <React.Fragment>
                                        <TableRow key={index}>
                                          <TableCell className="text-center">
                                            <IconButton
                                              aria-label="expand row"
                                              size="small"
                                              onClick={() =>
                                                this.setState({
                                                  open: !this.state.open,
                                                })
                                              }
                                            >
                                              {this.state.open ? (
                                                <KeyboardArrowUpIcon />
                                              ) : (
                                                <KeyboardArrowDownIcon />
                                              )}
                                            </IconButton>
                                          </TableCell>
                                          <TableCell className="text-center">
                                            {data.name}
                                          </TableCell>
                                          {this.state.taxrequired === true ? (
                                            <TableCell className="text-center">
                                              {data.hsn}
                                            </TableCell>
                                          ) : (
                                            ""
                                          )}
                                          <TableCell className="text-right">
                                            <NumericFormat
                                                displayType={"text"}
                                                value={data.price}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                disabled={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={
                                                  thousandsdisplay
                                                }
                                              ></NumericFormat>
                                          </TableCell>
                                          {this.state.currency !==
                                          this.state.basecurrency && (
                                            <TableCell className="text-right">
                                              <NumericFormat
                                                displayType={"text"}
                                                value={data.ccprice}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                disabled={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={
                                                  thousandsdisplay
                                                }
                                              ></NumericFormat>
                                            </TableCell>
                                          )}
                                          {this.state.currency !==
                                          this.state.basecurrency  && (
                                            <TableCell className="text-center">
                                              {data.pricevariance}
                                            </TableCell>
                                          )}
                                          {/* <TableCell className="text-center">
                                            {data.salesenum}
                                          </TableCell> */}
                                          <TableCell className="text-center">
                                            {data.quantity}
                                          </TableCell>
                                          <TableCell className="text-center">
                                            {data.uom}
                                          </TableCell>
                                          <TableCell className="text-right">
                                            <NumericFormat
                                              displayType={"text"}
                                              value={data.totalprice}
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                              disabled={true}
                                              thousandSeparator={true}
                                              thousandsGroupStyle={
                                                thousandsdisplay
                                              }
                                            ></NumericFormat>
                                          </TableCell>
                                          {this.state.currency !==
                                          this.state.basecurrency && (
                                            <TableCell className="text-right">
                                              <NumericFormat
                                                displayType={"text"}
                                                value={data.cctotalprice }
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                disabled={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={
                                                  thousandsdisplay
                                                }
                                              ></NumericFormat>
                                            </TableCell>
                                          )}
                                          {this.state.taxrequired === true ? (
                                            <>
                                              {this.state.taxtype === "GST" &&
                                              this.state.gsttype === "INTRASTATE" ? (
                                                <>
                                                  <TableCell className="text-right">
                                                    <NumericFormat
                                                      displayType={"text"}
                                                      value={data.taxamount / 2}
                                                      decimalScale={2}
                                                      fixedDecimalScale={true}
                                                      disabled={true}
                                                      thousandSeparator={true}
                                                      thousandsGroupStyle={
                                                        thousandsdisplay
                                                      }
                                                    ></NumericFormat>
                                                    &nbsp;({data.tax / 2}%)
                                                  </TableCell>
                                                  <TableCell className="text-right">
                                                    <NumericFormat
                                                      displayType={"text"}
                                                      value={data.taxamount / 2}
                                                      decimalScale={2}
                                                      fixedDecimalScale={true}
                                                      disabled={true}
                                                      thousandSeparator={true}
                                                      thousandsGroupStyle={
                                                        thousandsdisplay
                                                      }
                                                    ></NumericFormat>
                                                    &nbsp;({data.tax / 2}%)
                                                  </TableCell>
                                                  {this.state.currency !==
                                                  this.state.basecurrency && (
                                                    <>
                                                      <TableCell className="text-right">
                                                        <NumericFormat
                                                          displayType={"text"}
                                                          value={
                                                            (data.cctaxamount /2)}
                                                          decimalScale={2}
                                                          fixedDecimalScale={
                                                            true
                                                          }
                                                          disabled={true}
                                                          thousandSeparator={
                                                            true
                                                          }
                                                          thousandsGroupStyle={
                                                            thousandsdisplay
                                                          }
                                                        ></NumericFormat>
                                                        &nbsp;({data.tax / 2}%)
                                                      </TableCell>
                                                      <TableCell className="text-right">
                                                        <NumericFormat
                                                          displayType={"text"}
                                                          value={(data.cctaxamount /2)}
                                                          decimalScale={2}
                                                          fixedDecimalScale={
                                                            true
                                                          }
                                                          disabled={true}
                                                          thousandSeparator={
                                                            true
                                                          }
                                                          thousandsGroupStyle={
                                                            thousandsdisplay
                                                          }
                                                        ></NumericFormat>
                                                        &nbsp;({data.tax / 2}%)
                                                      </TableCell>
                                                    </>
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  <TableCell className="text-right">
                                                    <NumericFormat
                                                      displayType={"text"}
                                                      value={data.taxamount}
                                                      decimalScale={2}
                                                      fixedDecimalScale={true}
                                                      disabled={true}
                                                      thousandSeparator={true}
                                                      thousandsGroupStyle={
                                                        thousandsdisplay
                                                      }
                                                    ></NumericFormat>
                                                    &nbsp;({data.tax}%)
                                                  </TableCell>
                                                  {this.state.currency !==
                                                  this.state.basecurrency && (
                                                    <TableCell className="text-right">
                                                      <NumericFormat
                                                        displayType={"text"}
                                                        value={
                                                          data.cctaxamount
                                                        }
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        disabled={true}
                                                        thousandSeparator={true}
                                                        thousandsGroupStyle={
                                                          thousandsdisplay
                                                        }
                                                      >
                                                        &nbsp;({data.tax}%)
                                                      </NumericFormat>
                                                    </TableCell>
                                                  )}
                                                </>
                                              )}
                                              <TableCell className="text-right">
                                                <NumericFormat
                                                  displayType={"text"}
                                                  value={data.totalpricewtax}
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                  disabled={true}
                                                  thousandSeparator={true}
                                                  thousandsGroupStyle={
                                                    thousandsdisplay
                                                  }
                                                ></NumericFormat>
                                              </TableCell>
                                              {this.state.currency !== this.state.basecurrency && (
                                                <TableCell className="text-right">
                                                  <NumericFormat
                                                    displayType={"text"}
                                                    value={data.cctotalpricewtax}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    disabled={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={
                                                      thousandsdisplay
                                                    }
                                                  ></NumericFormat>
                                                </TableCell>
                                              )}
                                            </>
                                          ) : (
                                            ""
                                          )}

                                          <TableCell className="text-center">
                                            <span
                                              as="button"
                                              data-tip
                                              data-for="delete"
                                              className="fa fa-trash text-danger"
                                              style={{ paddingLeft: "7px" }}
                                              onClick={() =>
                                                this.removeItemFromList(index)
                                              }
                                            ></span>
                                          </TableCell>
                                        </TableRow>
                                        <TableRow>
                                          <TableCell
                                            style={{
                                              paddingBottom: 0,
                                              paddingTop: 0,
                                            }}
                                            colSpan={6}
                                          >
                                            <Collapse
                                              in={this.state.open}
                                              timeout="auto"
                                              unmountOnExit
                                            >
                                              <Box margin={1}>
                                                <Table
                                                  size="small"
                                                  aria-label="purchases"
                                                >
                                                  <TableHead>
                                                    <TableRow>
                                                      <TableCell align="center">
                                                        Brand
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        Model
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        Colour
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        Size
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        Thickness
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        TotalMtrRoll
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        Description
                                                      </TableCell>
                                                    </TableRow>
                                                  </TableHead>
                                                  <TableBody>
                                                    <TableRow key={index}>
                                                      <TableCell
                                                        component="th"
                                                        scope="row"
                                                        align="center"
                                                      >
                                                        {data.brand}
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        {data.model}
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        {data.colour}
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        {data.size}
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        {data.thickness}
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        {data.totalmtrroll}
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        {data.description}
                                                      </TableCell>
                                                    </TableRow>
                                                  </TableBody>
                                                </Table>
                                              </Box>
                                            </Collapse>
                                          </TableCell>
                                        </TableRow>
                                      </React.Fragment>
                                    ))}
                                    {/* <TableRow
                                      style={{
                                        textAlign: "center",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      <TableCell className="text-center">
                                        Total
                                      </TableCell>
                                      {this.state.taxrequired === true ? (
                                        <TableCell></TableCell>
                                      ) : (
                                        ""
                                      )}
                                      {this.state.currency ===
                                      this.state.basecurrency ? (
                                        ""
                                      ) : (
                                        <>
                                          <TableCell />
                                          <TableCell />
                                        </>
                                      )}
                                      <TableCell></TableCell>
                                      <TableCell></TableCell>
                                      <TableCell></TableCell>
                                      <TableCell></TableCell>
                                      <TableCell></TableCell>
                                      <TableCell className="text-right">
                                        <NumericFormat
                                          displayType={"text"}
                                          value={
                                            this.state.grandtotal -
                                            this.state.totaltaxamount
                                          }
                                          decimalScale={2}
                                          fixedDecimalScale={true}
                                          disabled={true}
                                          thousandSeparator={true}
                                          thousandsGroupStyle={thousandsdisplay}
                                        ></NumericFormat>
                                      </TableCell>
                                      {this.state.currency !==
                                      this.state.basecurrency && (
                                        <TableCell className="text-right">
                                          <NumericFormat
                                            displayType={"text"}
                                            value={
                                              (this.state.grandtotal -
                                                this.state.totaltaxamount)
                                            }
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            disabled={true}
                                            thousandSeparator={true}
                                            thousandsGroupStyle={
                                              thousandsdisplay
                                            }
                                          ></NumericFormat>
                                        </TableCell>
                                      )}
                                      {this.state.taxrequired === true ? (
                                        <>
                                          {this.state.taxtype === "GST" &&
                                          this.state.gsttype === false ? (
                                            <>
                                              <TableCell className="text-right">
                                                <NumericFormat
                                                  displayType={"text"}
                                                  value={
                                                    this.state.totaltaxamount /
                                                    2
                                                  }
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                  disabled={true}
                                                  thousandSeparator={true}
                                                  thousandsGroupStyle={
                                                    thousandsdisplay
                                                  }
                                                ></NumericFormat>
                                              </TableCell>
                                              <TableCell className="text-right">
                                                <NumericFormat
                                                  displayType={"text"}
                                                  value={
                                                    this.state.totaltaxamount /
                                                    2
                                                  }
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                  disabled={true}
                                                  thousandSeparator={true}
                                                  thousandsGroupStyle={
                                                    thousandsdisplay
                                                  }
                                                ></NumericFormat>
                                              </TableCell>
                                            </>
                                          ) : (
                                            <TableCell className="text-right">
                                              <NumericFormat
                                                displayType={"text"}
                                                value={
                                                  this.state.totaltaxamount
                                                }
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                disabled={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={
                                                  thousandsdisplay
                                                }
                                              ></NumericFormat>
                                            </TableCell>
                                          )}
                                          {this.state.currency ===
                                          this.state.basecurrency ? (
                                            ""
                                          ) : (
                                            <>
                                              {this.state.taxtype === "GST" &&
                                              this.state.gsttype === false ? (
                                                <>
                                                  <TableCell className="text-right">
                                                    <NumericFormat
                                                      displayType={"text"}
                                                      value={
                                                        (this.state
                                                          .totaltaxamount /
                                                          2) *
                                                        this.state
                                                          .curconversionrate
                                                      }
                                                      decimalScale={2}
                                                      fixedDecimalScale={true}
                                                      disabled={true}
                                                      thousandSeparator={true}
                                                      thousandsGroupStyle={
                                                        thousandsdisplay
                                                      }
                                                    ></NumericFormat>
                                                  </TableCell>
                                                  <TableCell className="text-right">
                                                    <NumericFormat
                                                      displayType={"text"}
                                                      value={
                                                        (this.state
                                                          .totaltaxamount /
                                                          2) *
                                                        this.state
                                                          .curconversionrate
                                                      }
                                                      decimalScale={2}
                                                      fixedDecimalScale={true}
                                                      disabled={true}
                                                      thousandSeparator={true}
                                                      thousandsGroupStyle={
                                                        thousandsdisplay
                                                      }
                                                    ></NumericFormat>
                                                  </TableCell>
                                                </>
                                              ) : (
                                                <TableCell className="text-right">
                                                  <NumericFormat
                                                    displayType={"text"}
                                                    value={
                                                      this.state
                                                        .totaltaxamount *
                                                      this.state
                                                        .curconversionrate
                                                    }
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    disabled={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={
                                                      thousandsdisplay
                                                    }
                                                  ></NumericFormat>
                                                </TableCell>
                                              )}
                                            </>
                                          )}
                                          <TableCell className="text-right">
                                            {this.state.grandtotal === "" ? (
                                              "0"
                                            ) : (
                                              <NumericFormat
                                                displayType={"text"}
                                                value={this.state.grandtotal}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                disabled={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={
                                                  thousandsdisplay
                                                }
                                              ></NumericFormat>
                                            )}
                                          </TableCell>
                                          {this.state.currency ===
                                          this.state.basecurrency ? (
                                            ""
                                          ) : (
                                            <TableCell className="text-right">
                                              {this.state.grandtotal === "" ? (
                                                "0"
                                              ) : (
                                                <NumericFormat
                                                  displayType={"text"}
                                                  value={
                                                    this.state.grandtotal *
                                                    this.state.curconversionrate
                                                  }
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                  disabled={true}
                                                  thousandSeparator={true}
                                                  thousandsGroupStyle={
                                                    thousandsdisplay
                                                  }
                                                ></NumericFormat>
                                              )}
                                            </TableCell>
                                          )}
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      <TableCell></TableCell>
                                    </TableRow> */}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </>
                          )}
                        </div>
                      )}
                    </div>

                    {this.state.salestype !== "0" ? (
                      <div className="form-row form-group col-md-12 tw-border tw-border-dotted tw-rounded-[10px] tw-mb-5 tw-pb-3 mx-0 p-0 pb-2 tw-group hover:tw-border-[#e4f0f7]" >
                      <div className="col-md-12 m-0 p-0 " >
                      {/* <h3 className="UI-section-title tw-w-full tw-bg-[#f4f4f4] group-hover:tw-bg-[#e4f0f7] tw-p-3">Service Details</h3> */}
                       <div className="tw-flex tw-items-center UI-section-title tw-p-3 tw-gap-2">
                        <div className={`tw-w-7 tw-h-7 tw-rounded-xl ${theme === 'classic' ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : ' tw-bg-sky-50 tw-text-sky-600'} tw-flex tw-items-center tw-justify-center tw-shrink-0`}>
                                          <WrenchIcon size={14} />
                                        </div>
                                        <h3 className=" ">Service Details</h3>
                                        </div> 
                      </div>
                      {this.state.salestype === "1" &&
                  <fieldset className=" col-md-3">
                                                <AutoCompeteField id="contracttype" name="contracttype" type="text" options={contracttypeList} valueKey={null} labelKey={null} value={this.state.contracttype} label={`Select Contract Type`} placeholder="" disabled={ this.state.grandtotal > 0} required error={errors?.contracttype} onChange={(e, value)=>this.setState({ contracttype: value,quantity:value ==="Milestone"?1:0 }) }/>
                            </fieldset>}
                        <fieldset className=" col-md-3">
                        <AutoCompeteField id="servicecategory" name="servicecategory" type="text" options={ServiceCategoryList} valueKey={"category"} labelKey={"category"} value={this.state.servicecategory} label={`Select Service Category`} placeholder="" disabled={ this.state.grandtotal > 0} required error={errors?.servicecategory} onChange={this.handleServicecategory}/>
                        </fieldset>

                        <fieldset className=" col-md-3">
                        <AutoCompeteField id="service" name="service" type="text" options={filterserv} valueKey={"service"} labelKey={"label"} value={this.state.service} label={`Select Service`} placeholder="" disabled={ this.state.grandtotal > 0} required error={errors?.service} onChange={this.handleService}/>
                        </fieldset>
                          <fieldset className=" col-md-3">
                          <TextfieldComponent type="text" name="servicecode" label="Service Code" value={this.state.servicecode} disabled/>
                          </fieldset>

                        <fieldset className=" col-md-3">
                        <TextfieldComponent type="number" name="servicecost" label="Amount" value={this.state.servicecostconv} onChange={(e)=>this.handleServiceAmountChange(e.target.value,this.state.quantity,this.state.servicemarkupconv,this.state.servicediscount)} error={errors?.servicecost} prefix={this.state.currency} required/>
                        </fieldset>

                        <fieldset className=" col-md-3">
                        <TextfieldComponent id="amount" type="number" name="markup" label="Markup" value={this.state.servicemarkupconv} onChange={(e)=>this.handleServiceAmountChange(this.state.servicecostconv,this.state.quantity,e.target.value === undefined?0:e.target.value,this.state.servicediscount)}  prefix={this.state.currency} />
                        </fieldset>
                        <fieldset className=" col-md-3">
                        <TextfieldComponent id="standard-adornment-amount" value={this.state.servicediscount} label={"Discount"} type="number" onChange={(e) =>this.handleServiceAmountChange(this.state.servicecostconv,this.state.quantity,this.state.servicemarkupconv,e.target.value === undefined?0:e.target.value)}  prefix={"%"}/>
                          </fieldset>

                        <fieldset className=" col-md-3">
                          <TextfieldComponent id="quantity"   value={this.state.quantity || 0} className="form-control" type="number" name="quantity" label={`Quantity`} required min="0" disabled={this.state.contracttype === "Milestone"}
                            onChange={(e) => {
                              this.setState({ quantity: e.target.value === undefined ? 0 : e.target.value, })
                              this.handleServiceAmountChange(this.state.servicecostconv, e.target.value, this.state.servicemarkupconv, this.state.servicediscount)
                            }}
                          />
                        </fieldset>

                        {this.state.taxrequired === true && <>
                          <fieldset className="form-group col-md-3">
                            <SelectField id="tax" label={`Select Tax(%)`} list={[{ tax: "", description: "" }, ...this.state.taxesList.map((e => { return { ...e, description: e.tax } }))]} lableKey={"description"} lableValue={"tax"} name="tax" value={this.state.servicetax} onChange={(e) => this.setState({ servicetax: e.target.value }, () => this.handleServiceAmountChange(this.state.servicecostconv, this.state.quantity, this.state.servicemarkupconv, this.state.servicediscount))} />
                          </fieldset>
                          {this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE" ? <>
                            <fieldset className=" col-md-3 tw-flex tw-gap-1">
                              <TextfieldComponent type="number" name="servicecgst" label={`CGST`} value={this.state.servicetax / 2} prefix={"%"} disabled />
                              <TextfieldComponent type="number" name="servicesgst" label={`SGST`} value={this.state.servicetax / 2} prefix={"%"} disabled />
                            </fieldset>
                          </>
                            :
                            <fieldset className=" col-md-3">
                              <TextfieldComponent type="number" name="servicetax" label={`${this.state.taxtype === "GST" && ccountry === "India" ? "IGST" : this.state.taxtype}`} value={this.state.servicetax} disabled prefix={"%"} />
                            </fieldset>
                          }
                        </>}

                        {this.state.currency !== this.state.basecurrency && 
                        <fieldset className="col-md-3">
                          <TextfieldComponent
                            type="number"
                            name="servicecostwttaxconv"
                            label={`Total Amount`}
                            value={this.state.servicecostwttaxconv}
                            prefix={this.state.currency}
                            disabled
                          />
                        </fieldset>
                        }
                        <fieldset className=" col-md-3">
                          <TextfieldComponent
                            type="number"
                            name="servicecostwttax"
                            label="Total Amount"
                            value={this.state.servicecostwttax}
                            prefix={this.state.basecurrency}
                            disabled
                          />
                        </fieldset>

                        {this.state.salestype === "1" ? (
                          <>
                            

                            {this.state.contracttype === "Recurring" ? (
                              <>
                                <fieldset className=" col-md-3">

                                <SelectField
                                id="subaccount"
                                name="contracttime"
                                list={recurringtype}
                                labelKey={null}
                                valueKey={null}
                                label="Select Recurring Period"
                                value={this.state.contracttime}
                                onChange={(e, value) => {
                                  setFieldValue("contracttime", value);
                                  this.setState({ contracttime: e.target.value })
                                }}
                              />
                                </fieldset>
                                {this.state.contracttime !== "NotApplicable" &&
                                <fieldset className="mr-4">
                                   <DatePickerField disableFuture={false} disablePast={true} minDate={transactionFrom ? dayjs(transactionFrom) : dayjs("1900-01-01")} label={"Custom Sale Order Date"} value={this.state.contractstartdate} onDateChange={this.handleStartDateChange} timePicker={false}  />
                                </fieldset>}
                              </>
                            ) : (
                              ""
                            )}
                            {this.state.contracttype === "Milestone" ? (
                              <div className="form-group col-md-12">
                                <Accordion expanded={true}>
                                  <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    style={{ backgroundColor: "#e8ecef" }}
                                  >
                                    <Typography>MileStones</Typography>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    <FieldArray
                                      name="milestone"
                                      render={(arrayHelpers) => (
                                        <div className="form-group col-md-12">
                                          {values.milestone.map(
                                            (data, index) => (
                                              <div
                                                key={index}
                                                className="form-row"
                                              >
                                                {/** both these conventions do the same */}
                                                <fieldset className="form-group col-md-2">
                                                  <FormikTextField
                                                    className="form-control"
                                                    name={`milestone[${index}].name`}
                                                    label="Name"
                                                    variant="standard"
                                                    fullWidth
                                                  />
                                                </fieldset>
                                                <fieldset className="form-group col-md-2">
                                                  <FormikTextField
                                                    className="form-control"
                                                    id="amount"
                                                    type="number"
                                                    min={1}
                                                    max={100}
                                                    name={`milestone.${index}.percentage`}
                                                    label="Percentage (%)"
                                                    variant="standard"
                                                    onBlur={() =>
                                                      setFieldValue(
                                                        `milestone.${index}.amountwttax`,
                                                        (data.percentage /
                                                          100) *
                                                          (parseFloat(
                                                            this.state
                                                              .servicecost
                                                          ) +
                                                            (servicetax / 100) *
                                                              parseFloat(
                                                                this.state
                                                                  .servicecost
                                                              ))
                                                      ) &&
                                                      setFieldValue(
                                                        `milestone.${index}.amount`,
                                                        (data.percentage /
                                                          100) *
                                                          parseFloat(
                                                            this.state
                                                              .servicecost
                                                          )
                                                      )
                                                    }
                                                    fullWidth
                                                  />
                                                </fieldset>
                                                <fieldset className="form-group col-md-2">
                                                  <FormikTextField
                                                    className="form-control"
                                                    type="number"
                                                    name={`milestone.${index}.amount`}
                                                    label="Amount"
                                                    variant="standard"
                                                    fullWidth
                                                    disabled
                                                  ></FormikTextField>
                                                </fieldset>
                                                {this.state.taxrequired ===
                                                true ? (
                                                  <fieldset className="form-group col-md-2">
                                                    <FormikTextField
                                                      className="form-control"
                                                      type="number"
                                                      name={`milestone.${index}.amountwttax`}
                                                      label="Amount inc.Tax"
                                                      variant="standard"
                                                      fullWidth
                                                      disabled
                                                    ></FormikTextField>
                                                  </fieldset>
                                                ) : (
                                                  ""
                                                )}
                                                <fieldset className="form-group col-md-3">
                                                  <FormikTextField
                                                    id="date"
                                                    label="Expected Date"
                                                    name={`milestone.${index}.expecteddate1`}
                                                    type="date"
                                                    minDate={new Date()}
                                                    className={
                                                      useStyles.textField
                                                    }
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                  />
                                                </fieldset>
                                                {values.milestone.length !==
                                                1 ? (
                                                  <span
                                                    type="button"
                                                    className="fa fa-minus-square text-danger mt-4"
                                                    onClick={() =>
                                                      arrayHelpers.remove(index)
                                                    }
                                                  ></span>
                                                ) : (
                                                  ""
                                                )}
                                                <span
                                                  type="button"
                                                  className="fa fa-plus-square text-info mt-4 ml-3"
                                                  onClick={() =>
                                                    arrayHelpers.push({
                                                      name: "",
                                                      expecteddate1: "",
                                                      percentage: 0,
                                                      amount: 0,
                                                      amountwttax: 0,
                                                    })
                                                  }
                                                ></span>
                                              </div>
                                            )
                                          )}
                                          <p
                                            className={`${
                                              this.state.percentagemessage ===
                                              "Milestones Saved Scussesfully"
                                                ? "text-green"
                                                : "text-danger"
                                            }`}
                                          >
                                            {this.state.percentagemessage}
                                          </p>
                                          <span
                                            as="button"
                                            className="btn btn-sm float-right"
                                            onClick={() =>
                                              this.handlemilestonevalues(
                                                values.milestone
                                              )
                                            }
                                          >
                                            <i
                                              className={`${
                                                this.state.milestonesavebtn ===
                                                false
                                                  ? "fa fa-save"
                                                  : "fa fa-check text-green"
                                              } mr-1`}
                                            />
                                            Confirm
                                          </span>
                                        </div>
                                      )}
                                    />
                                  </AccordionDetails>
                                </Accordion>
                                {this.state.milestone.length === 0 ? (
                                  ""
                                ) : (
                                  <TableContainer>
                                    <Table className="table-sm mt-4">
                                      <TableHead>
                                        <TableRow>MileStones</TableRow>
                                      </TableHead>
                                      <TableHead className="text-sm">
                                        <TableRow
                                          style={{ textAlign: "center" }}
                                        >
                                          <TableCell className="text-center">
                                            Name
                                          </TableCell>
                                          <TableCell className="text-center">
                                            Expected Date
                                          </TableCell>
                                          <TableCell className="text-center">
                                            Percentage (%)
                                          </TableCell>
                                          <TableCell className="text-center">
                                            Amount
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {this.state.milestone.map(
                                          (data, index) => (
                                            <TableRow key={index}>
                                              <TableCell className="text-center">
                                                {data.name}
                                              </TableCell>
                                              <TableCell className="text-center">
                                                {moment(
                                                  data.expecteddate1
                                                ).format("DD-MM-YYYY")}
                                              </TableCell>
                                              <TableCell className="text-center">
                                                {data.percentage} %
                                              </TableCell>
                                              <TableCell className="text-right">
                                                <NumericFormat
                                                  displayType={"text"}
                                                  value={data.amount}
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                  disabled={true}
                                                  thousandSeparator={true}
                                                  thousandsGroupStyle={
                                                    thousandsdisplay
                                                  }
                                                ></NumericFormat>
                                              </TableCell>
                                            </TableRow>
                                          )
                                        )}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                )}
                              </div>
                            ) : (
                              ""
                            )}
                           
                          </>
                        ) : (
                          ""
                        )}

                          <fieldset fieldset className="col-md-12">
                            <TextareaField name="servicedescription" className="form-control" multiline rows={2} label="Description" variant="outlined" value={this.state.servicedescription}
                              onChange={(e) => this.setState({ servicedescription: e.target.value })} required maxLength={200}
                            />
                          </fieldset>

                        {this.state.contracttype !== "Milestone" && <><div className="tw-flex tw-justify-end tw-w-full">
                            <span
                              as="button"
                              className="btn btn-sm hovbuttonColour m-0 ml-1"
                              onClick={this.handleaddService}
                            >
                              Add Service
                            </span>
                            </div>
                            <div className=" col-md-12 text-red text-sm">
                              {this.state.serviceerr}
                            </div>
                            
                            </>}
                            {this.state.serviceList.length > 0 && (
                              <TableContainer className="tw-border tw-border-dotted tw-rounded-[10px] tw-pb-2 mx-0 tw-mt-1" >
                                <Typography><h3 className="UI-section-title tw-w-full tw-bg-[#f4f4f4] tw-p-3 !tw-mb-0"> Services List</h3></Typography>
                              <Table className="table-sm">
                                <TableHead>
                                  <TableRow style={{ textAlign: "center" }}>
                                    <TableCell>Service</TableCell>
                                    <TableCell>Quantity</TableCell>
                                    <TableCell>Service Code</TableCell>
                                    <TableCell>Service Description</TableCell>
                                    <TableCell>Service Cost({this.GetCurrencySymbol(this.state.basecurrency)})</TableCell>
                                    {this.state.currency === this.state.basecurrency?'':<TableCell>Service Cost({this.GetCurrencySymbol(this.state.currency)})</TableCell>}
                                    {this.state.taxrequired===true?<>
                                    {this.state.taxtype === "GST" && ccountry ==="India" ? this.state.gsttype === "INTRASTATE" ?
                                      (<><TableCell>CGST in {this.state.basecurrency} (%)</TableCell><TableCell>SGST in {this.state.basecurrency} (%)</TableCell></>) : (<TableCell>IGST in {this.state.basecurrency}</TableCell>) :
                                      this.state.taxtype === "GST" ?<TableCell>GST in {this.state.basecurrency}(%)</TableCell>: <TableCell>VAT in {this.state.basecurrency} (%)</TableCell>}
                                     {this.state.currency !== this.state.basecurrency &&  <>{this.state.taxtype === "GST" && ccountry ==="India" ? this.state.gsttype === "INTRASTATE" ?
                                      (<><TableCell>CGST in {this.state.currency} (%)</TableCell><TableCell>SGST in {this.state.currency} (%)</TableCell></>) : (<TableCell>IGST in {this.state.currency} (%)</TableCell>) :
                                      this.state.taxtype === "GST" ?<TableCell>GST in {this.state.currency} (%)</TableCell>: <TableCell>VAT in {this.state.currency} (%)</TableCell>}</>}
                                    </>:''}
                                    
                                    <TableCell>Total({this.GetCurrencySymbol(this.state.basecurrency)})</TableCell>
                                    {this.state.currency === this.state.basecurrency?'':<TableCell>Total({this.GetCurrencySymbol(this.state.currency)})</TableCell>}
                                    <TableCell>Action</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {this.state.serviceList.map((data, index) => (
                                    <TableRow
                                      key={index}
                                      style={{ textAlign: "center" }}
                                    >
                                      <TableCell>{data.service}</TableCell>
                                      <TableCell>{data.quantity}</TableCell>
                                      <TableCell>{data.servicecode}</TableCell>
                                      <TableCell>
                                        {data.servicedescription || data.description}
                                      </TableCell>
                                      <TableCell><NumericFormat displayType={'text'} decimalScale={2} fixedDecimalScale={true} disabled={true} value={data.servicecost} thousandSeparator={true} thousandsGroupStyle={thousandsdisplay}></NumericFormat></TableCell>
                                      {this.state.currency !== this.state.basecurrency && <TableCell><NumericFormat displayType={'text'} decimalScale={2} fixedDecimalScale={true} disabled={true} value={data.ccservicecost} thousandSeparator={true} thousandsGroupStyle={thousandsdisplay}></NumericFormat></TableCell>}
                                      {this.state.taxrequired===true?<>
                                      {this.state.taxtype === "GST" && ccountry ==="India" && this.state.gsttype === "INTRASTATE" ?<><TableCell>{data.servicetaxamount/2}({data.servicetax/2}%)</TableCell><TableCell>{data.servicetaxamount/2}({data.servicetax/2}%)</TableCell></>:<TableCell>{data.servicetaxamount}({data.servicetax}%)</TableCell>}
                                      {this.state.currency !== this.state.basecurrency &&<>{this.state.taxtype === "GST" && ccountry ==="India" && this.state.gsttype === "INTRASTATE" ?<><TableCell>{data.ccservicetaxamount/2}({data.servicetax/2}%)</TableCell><TableCell>{data.ccservicetaxamount/2}({data.servicetax/2}%)</TableCell></>:<TableCell>{data.ccservicetaxamount}({data.servicetax}%)</TableCell>}</>}
                                      </>:''}
                                      <TableCell><NumericFormat displayType={'text'} decimalScale={2} fixedDecimalScale={true} disabled={true} value={data.servicecostwttax || data.servicetotalwtax} thousandSeparator={true} thousandsGroupStyle={thousandsdisplay}></NumericFormat></TableCell>
                                      {this.state.currency !== this.state.basecurrency && <TableCell><NumericFormat displayType={'text'} decimalScale={2} fixedDecimalScale={true} disabled={true} value={data.ccservicecostwttax || data.ccservicetotalwtax} thousandSeparator={true} thousandsGroupStyle={thousandsdisplay}></NumericFormat></TableCell>}
                                      <TableCell>
                                        <span
                                          className="fa fa-trash text-danger cursorPointer"
                                          style={{ paddingLeft: "7px" }}
                                          onClick={() =>
                                            this.removeServiceFromList(index)
                                          }
                                        ></span>
                                      </TableCell>
                                    
                                    </TableRow>
                                  ))}
                                  <TableRow style={{ textAlign: "center" }}>
                                  {this.state.taxrequired && this.state.taxtype === "GST" && ccountry ==="India" && this.state.gsttype === "INTRASTATE" && 
                                 <>{this.state.currency !== this.state.basecurrency?<><TableCell/><TableCell/></> :<TableCell/>}</>}
                                  {this.state.taxrequired && <>{this.state.currency !== this.state.basecurrency?<><TableCell/><TableCell/></> :<TableCell/>}</>}
                                    {this.state.currency !== this.state.basecurrency && <TableCell/>}
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell>
                                      {this.state.grandservicetotal === ""? 0: <NumericFormat displayType={'text'} decimalScale={2} fixedDecimalScale={true} disabled={true} value={parseFloat(this.state.grandservicetotal)} thousandSeparator={true} thousandsGroupStyle={thousandsdisplay}   ></NumericFormat>}
                                    </TableCell>
                                    {this.state.currency !== this.state.basecurrency && <TableCell>
                                      {this.state.grandservicetotal === ""? 0: <NumericFormat displayType={'text'} decimalScale={2} fixedDecimalScale={true} disabled={true} value={parseFloat(this.state.ccgrandservicetotal)} thousandSeparator={true} thousandsGroupStyle={thousandsdisplay}   ></NumericFormat>}</TableCell>}
                                   <TableCell></TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>
                            )}

                      </div>
                    ) : (
                      ""
                    )}

                  <div className="row form-group col-md-12 tw-border tw-border-dotted tw-rounded-[10px] tw-mb-5 tw-pb-3 mx-0 px-2 tw-group hover:tw-border-[#e4f0f7]" >
                      <div className="col-md-12 m-0 p-0 " >
                      <div className="tw-flex tw-items-center UI-section-title tw-p-3 tw-gap-2">
                        <div className={`tw-w-7 tw-h-7 tw-rounded-xl ${theme === 'classic' ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : ' tw-bg-sky-50 tw-text-sky-600'} tw-flex tw-items-center tw-justify-center tw-shrink-0`}>
                                          <Plus size={14} />
                                        </div>
                                        <h3 className=" ">Other Order Details</h3>
                                        </div> 
                      </div>
                          <fieldset className="form-group col-md-4">
                            <RoundedTabButton label={"Request Advance Payment"}  checked={this.state.advancestatus} onClick={this.handleadvancestatus}/>
                          </fieldset>
                          {this.state.advancestatus === true ? (
                            <>
                              {this.state.currency ===
                              this.state.basecurrency ? (
                                ""
                              ) : (
                                <fieldset className="form-group col-md-3">
                                  <TextfieldComponent
                                    className="form-control"
                                    type="number"
                                    name="advancecnvt"
                                    onChange={this.handleAdvanceAmountcnvtChange}
                                    label={`Advance Amount`}
                                    value={this.state.advancecnvt}
                                    prefix={this.state.currency}
                                    variant="standard"
                                    fullWidth
                                  />
                                </fieldset>
                              )}
                               <fieldset className="form-group col-md-2">
                                <TextfieldComponent
                                  className="form-control"
                                  type="number"
                                  name="advance"
                                  onChange={this.handleAdvanceAmountChange}
                                  // onBlur={this.handleAdvanceAmountBlur}
                                  label="Advance Amount"
                                  variant="standard"
                                  fullWidth
                                  prefix={this.state.basecurrency}
                                />
                              </fieldset>
                            </>
                          ) : (
                            ""
                          )}
                       <fieldset className="form-group col-md-3 text-md">
                      <TextfieldComponent label={"Payment Terms"} id={"paymentterms"} name="paymentterms" value={this.state.paymentterms} onChange={(e)=>this.setState({paymentterms:parseInt(e.target.value)>120?120:parseInt(e.target.value)})} prefix={"Days"} />
                      </fieldset>
                    </div>

                    <div className="tw-flex tw-justify-end">
  <button
    className={"UI-btn UI-btn-primary"}
    type="button"
    disabled={
      this.state.sloader === true ||
      (
        this.state.salestype === "1" &&
        (
          (this.state.contracttype !== "Milestone" && this.state.serviceList.length === 0) ||
          (this.state.contracttype === "Milestone" && this.state.milestone.length === 0)
        )
      ) ||
      (
        this.state.salestype !== "1" &&
        this.state.grandtotal === 0
      )
    }
    onClick={
      !(
        this.state.sloader === true ||
        (
          this.state.salestype === "1" &&
          (
            (this.state.contracttype !== "Milestone" && this.state.serviceList.length === 0) ||
            (this.state.contracttype === "Milestone" && this.state.milestone.length === 0)
          )
        ) ||
        (
          this.state.salestype !== "1" &&
          this.state.grandtotal === 0
        )
      )
        ? this.handleSubmit
        : undefined
    }
  >
    {this.state.sloader === true ? (
      <>
        <Spinner animation="border" size="sm" className="mr-1" />
        Saving...
      </>
    ) : "Save"}
  </button>

  <Link
    as="button"
    className="UI-btn UI-btn-outline ml-3"
    to={{ pathname: "/quotation" }}
  >
    Cancel
  </Link>
</div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
export default withRouter(NewQuotation);
